export const questions = {
    "quizTitle": "CAA Clasa C",
    "quizSynopsis": "Examen Clasa C · 26 întrebări · 30 min · minim 22 corecte",
    "progressBarColor": "#9de1f6",
    "nrOfQuestions": "517",
    "examConfig": {
        "personnelCategory": "CLASA C",
        "timeMinutes": 30,
        "passPercent": 85,
        "minCorrect": 22,
        "barem": null,
        "modelName": "Examen Clasa C",
        "sections": [
            {
                "id": "C-COLREG",
                "label": "COLREG",
                "count": 10,
                "difficulty": 1
            },
            {
                "id": "C-Navigatie",
                "label": "Navigație maritimă",
                "count": 3,
                "difficulty": 1
            },
            {
                "id": "C-Manevra",
                "label": "Conducerea și manevra ambarcațiunii",
                "count": 3,
                "difficulty": 1
            },
            {
                "id": "C-Marinarie",
                "label": "Marinărie",
                "count": 6,
                "difficulty": 1
            },
            {
                "id": "C-PrimAjutor",
                "label": "Prim ajutor",
                "count": 2,
                "difficulty": 1
            },
            {
                "id": "C-Legislatie",
                "label": "Legislație maritimă",
                "count": 2,
                "difficulty": 1
            }
        ],
        "totalQuestions": 26
    },
    "appLocale": {
        "landingHeaderText": "<questionLength> Intrebari",
        "question": "Intrebare",
        "startQuizBtn": "Incepe",
        "resultFilterAll": "Toate",
        "resultFilterCorrect": "Correct",
        "resultFilterIncorrect": "Incorect",
        "prevQuestionBtn": "Inapoi",
        "nextQuestionBtn": "Inainte",
        "multipleSelectionTagText": "Selectie multipla",
        "resultPageHeaderText": "Ai terminat. Ai <correctIndexLength> raspunsuri corecte din <questionLength> total.",
        "pickNumberOfSelection": "Alege <numberOfSelection>",
        "marksOfQuestion": "(<marks> puncte)"
    },
    "questions": [
        {
            "question": "1. Căror nave li se aplică prevederile Colreg-1972?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tuturor navelor care navigă în apele internaționale.",
                "b) tuturor navelor care navigă în rade, strâmtori și marea liberă.",
                "c) tuturor navelor aflate în largul mării ori pe toate apele învecinate accesibile navelor maritime."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "2. Tuturor navelor aflate în largul mării ori pe toate apele învecinate accesibile navelor maritime li se aplică prevederile:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) COLREG-1972.",
                "b) R.N.D.",
                "c) Codului ISPS."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "3. Dispozițiile Regulamentului împiedică aplicarea prescripțiilor speciale stabilite de către autoritatea competentă referitoare la navigația în rade, porturi, pe fluvii, lacuri sau căi de navigaţie interioară accesibile navelor maritime?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da.",
                "b) nu.",
                "c) nu este precizat."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "4. Cum influenţează prevederile Regulamentului prescripţiile speciale referitoare la navigaţia în rade, porturi, pe fluvii, lacuri sau căi de navigaţie interioară accesibile navelor maritime?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dispoziţiile regulamentului nu trebuie să împiedice aplicarea prescripţiilor speciale stabilite de către autoritatea competentă, dar asemenea prescripţii speciale trebuie să fie cât mai conforme cu prezentele reguli.",
                "b) autoritatea competentă nu este obligată să ţină seama de prescripţiile Regulamentului.",
                "c) în toate situaţiile se vor aplica prevederile Regulamentului."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "5. Guvernul unui stat poate stabili prescripţiile speciale cu privire la numărul luminilor de poziţie, a semnalelor luminoase, prescripţii care să fie astfel încât să facă imposibilă confundarea lor cu Regulamentul?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu.",
                "b) nu este precizat.",
                "c) da."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "6. Dispoziţiile Regulamentului scutesc nava, comandantul sau armatorul de consecinţele unei neglijenţe oarecare în ceea ce priveşte aplicarea Regulamentului sau în ceea ce priveşte luarea tuturor măsurilor cerute de o bună practică marinărească?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu este precizat.",
                "b) da.",
                "c) nu."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "7. Când este exonerată o navă, comanantul sau armatorul de consecinţele unei neglijenţe sau de neluarea tuturor măsurilor cerute de o bună practică marinărească?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) aplicarea regulilor scuteşte nava, comandantul sau armatorul de orice răspundere.",
                "b) conformarea întocmai la prevederile regulii \"navă privilegiată\" scuteşte nava, comandantul sau armatorul de orice răspundere.",
                "c) dispoziţiile Regulamentului nu scutesc nava, comandantul sau armatorul de consecinţele unei neglijenţe oarecare în ceea ce priveşte aplicarea Regulamentului sau în ceea ce priveşte luarea tuturor măsurilor cerute de o bună practică marinărească."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "8. Când există riscul unei coliziuni, precum şi în toate împrejurările deosebite sunt permise:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) abaterea de la prevederile Regulamentului.",
                "b) abateri de la prevederile autorităţilor portuare.",
                "c) abateri de la prevederile legilor specifice."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "9. Când sunt permise abateri de la prevederile Regulamentului?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în apele naţionale, rade şi în toate apele învecinate accesibile navelor maritime.",
                "b) când există pericol de navigaţie, riscul unei coliziuni, precum şi în toate împrejurările deosebite.",
                "c) indiferent de situaţie, nu este permisă abaterea de la prevederile Regulamentului."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "10. Ce se înţelege prin expresia\"navă\", conform Regulamentului?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) orice construcţie sau aparat, de orice natură, capabil să plutească pe apă fără propulsie.",
                "b) orice construcţie sau orice aparat, de orice natură ar fi, inclusiv construcţiile fără pescaj şi hidro avioane, folosite sau susceptibile de a fi folosite ca mijloc de transport pe apă.",
                "c) orice corp plutitor cu orice mijloc de propulsie."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "11. Ce se înţelege prin \"navă cu propulsie mecanică\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) orice navă pusă în mişcare de către o maşină.",
                "b) navele care folosesc ca mijloc de propulsie un motor Diesel.",
                "c) toate navele care se pot deplasa pe apă, cu excepţia navelor cu vele."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "12. O navă care navigă cu vele, chiar dacă are o maşină proprie, cu condiţia ca aceasta să nu fie folosită, reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o navă cu vele.",
                "b) o navă cu propulsie mecanică, care foloseşte şi velele.",
                "c) o navă care foloseşte ca mijloc de propulsie forţa vântului."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "13. Ce se înţelege prin expresia \"navă cu vele\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o navă care foloseşte ca mijloc de propulsie forţa vântului.",
                "b) o navă cu propulsie mecanică, care foloseşte şi vele.",
                "c) o navă care navigă cu vele, chiar dacă are o maşină proprie, cu condiţia ca aceasta să nu fie folosită."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "14. O navă care din cauza unei împrejurări excepţionale nu este în măsură să manevreze şi deci, nu poate să se îndepărteze din drumul altei nave trebuie considerată:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nava nu este stăpână pe manevra sa.",
                "b) navă cu capacitate de manevră redusă.",
                "c) navă stânjenită de pescajul său."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "15. Ce se înţelege prin expresia \"navă cu capacitate de manevră redusă\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o navă a cărei capacitate de manevră conform Regulamentului este limitată prin natura lucrărilor sale şi care, în consecinţă, nu se poate îndepărta din drumul altei nave.",
                "b) o navă cu avarii accidentale la cârmă şi/sau maşină, în curs de remediere.",
                "c) o navă care nu se poate abate din drumul său, datorită unor pericole de navigaţie."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "16. O navă cu propulsie mecanică, care din cauza pescajului şi a adâncimii apei sub chilă poate să-şi modifice cu greu drumul, se consideră :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navă stânjenită de pescajul său.",
                "b) navă cu lungime mai mare de 200 m",
                "c) navă cu capacitate de manevră redusă."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "17. O navă care nu este nici la ancoră, nici legată la cheu, nici eşuată se consideră:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navă \"în marş\".",
                "b) navă în derivă.",
                "c) navă care ţine la capă."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "18. Când una dintre nave poate fi observată vizual de către cealaltă navă, se consideră:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navă în siguranţă.",
                "b) nave aflate în vedere.",
                "c) nave în marş."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "19. Când două nave se consideră în vedere?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) când se observă vizual reciproc.",
                "b) numai când una dintre ele poate fi observată vizual de către cealaltă.",
                "c) când navele se află în limita de observare cu radarul."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "20. Cum trebuie să se asigure veghea la bordul navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) trebuie să se asigure în permanenţă o veghe vizuală şi auditivă corespunzătoare, folosind în acelaşi timp toate mijloacele disponibile, potrivit cu împrejurările şi condiţiile existente, în aşa fel încât să permită o apreciere completă a situaţiei.",
                "b) trebuie să se asigure în permanenţă o veghe vizuală pentru evitarea unei situaţii periculoase.",
                "c) în condiţii de vizibilitate redusă, se va organiza o veghe corespunzătoare, pentru a aprecia existenţa unui pericol de coliziune."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "21. Pentru a se putea acţiona corect şi eficace pentru prevenirea unei coliziuni şi pentru ca nava să poată fi oprită pe o distanţă corespunzătoare împrejurărilor şi condiţiilor, se impune menţiunea de a naviga cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) viteză maximă.",
                "b) viteză minimă.",
                "c) viteză de siguranţă."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "22. Care sunt factorii care trebuie luaţi în consideraţie pentru determinarea \"vitezei de siguranţă\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lungimea navei, calităţile nautice ale navei, puterea maşinii şi vizibilitatea.",
                "b) pregătirea echipajului, condiţiile de navigaţie, vizibilitatea.",
                "c) vizibilitatea, densitatea traficului, capacitatea de manevră a navei, noaptea-existenţa unui fundal luminos, starea vântului şi a mării, pescajul navei."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "23. Orice navă trebuie să folosească toate mijloacele disponibile corespunzătoare împrejurărilor şi condiţiilor externe pentru a stabili dacă există:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un pericol de eşuare.",
                "b) un pericol iminent.",
                "c) un pericol de coliziune."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "24. Ce mijloace trebuie să folosească o navă pentru a stabili dacă există pericolul de coliziune?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) orice navă trebuie să folosească toate mijloacele disponibile corespunzătoare împrejurărilor şi condiţiilor extrene, pentru a stabili dacă există un pericol de coliziune.",
                "b) orice navă trebuie să folosească toate mijloacele vizuale, pentru a stabili dacă există pericolul de coliziune.",
                "c) orice navă trebuie să folosească radarul, pentru a stabili dacă există pericolul de coliziune."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "25. Când relevmentul compas la o navă care se apropie nu variază în mod apreciabil, se consideră :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nave în vedere.",
                "b) pericol de coliziune.",
                "c) nave cu drumuri opuse."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "26. Când se consideră că există pericol de coliziune?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) când navele navigă în drumuri opuse.",
                "b) când relevmentul compas la o navă care se apropie nu variază în mod apreciabil.",
                "c) când viteza de apropiere între cele două nave este foarte mare."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "27. Cum trebuie să se execute o manevră pentru evitarea unei coliziuni?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) din timp, cu schimbări mici de drum, pentru a nu devia prea mult de la drumul navei.",
                "b) hotărât, din timp şi conform cu buna practică marinărească.",
                "c) hotărât, cu variaţii de viteză, pentru evitarea pericolului."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "28. Cum trebuie să se execute schimbările de drum şi/sau de viteză pentru evitarea ueni coliziuni?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) schimbări mici de drum şi/sau de viteză, pentru a nu devia prea mult de la drumul navei.",
                "b) schimbări destul de mari de viteză şi mici de drum, pentru a nu devia prea mult de la drumul navei.",
                "c) dacă împrejurările permit, să fie destul de mare, pentru a putea fi percepută imediat de orice navă care o observă vizual sau cu radarul."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "29. Dacă pentru evitarea unei coliziuni este suficientă numai schimbarea de drum, cum trebuie să fie executată?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) manevra se va face cu mult timp înainte, să fie substanţială şi să nu conducă la o altă situaţie de foarte mare apropiere.",
                "b) se vor executa schimbări mari de drum, suficiente pentru evitarea coliziunii.",
                "c) se va efectua o schimbare de drum suficientă pentru ca să se elimine orice pericol de coliziune."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "30. Manevra de evitare între nave se va efectua astfel încât să permită trecerea la:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o distanţă maximă.",
                "b) o distanţă de siguranţă.",
                "c) o distanţă minimă."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "31. Până când se controlează eficacitatea unei manevre de evitare?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) până când navele vor fi la travers una faţă de cealaltă.",
                "b) până când nava cealaltă va fi într-un unghi de 45° tribord/babord.",
                "c) până când nava cealaltă a fost complet şi definitiv depăşită."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "32. Care este manevra cea mai indicată pentru a se câştiga mai mult timp pentru aprecierea situaţiei, atunci când trebuie să se evite o coliziune?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) reducerea vitezei sau opirea completă, stopând maşinile ori punându-le înapoi.",
                "b) stoparea navei.",
                "c) reducerea la minimum de viteză, până la limita guvernării."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "33. Cum se navigă în şenal sau cale navigabilă îngustă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pe mijlocul şenalului sau căii de acces.",
                "b) cât mai aproape posibil de marginea exterioară din dreapta şenalului sau căii de acces respective, atunci când aceasta se poate face.",
                "c) se va naviga întotdeauna cât mai aproape posibil de marginea exterioară a şenalului sau căii de acces, pentru asigurarea unei veghe corespunzătoare."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "34. Ce semnale pot da navele care navigă prin şenal şi se îndoiesc de intenţiile navei care traversează şenalul?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un sunet lung şi două scurte.",
                "b) un semnal de avertizare compus din cinci sunete scurte.",
                "c) un semnal lung de atenţionare."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "35. Ce măsuri de siguranţă trebuie să ia o navă care se apropie de un cot aflat într-un şenal sau o cale de acces îngustă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să emită cinci sunete scurte (de avertizare)",
                "b) să emită un semnal scurt şi să navige pe partea dreaptă a şenalului.",
                "c) să emită un semnal lung şi să navige cu prudenţă şi vigilenţă."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "36. Schemelor de separare a traficului li se aplică reglementările referitoare la schemele de separare a traficului, adoptate de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) guvernele ţărilor unde se află schemele.",
                "b) Organizaţie.",
                "c) Organizaţie şi guvernele anumitor ţări."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "37. Nava trebuie să navige pe banda de navigaţie corespunzătoare în direcţia generală a traficului şi să se îndepărteze,în măsura posibilului, de linia sau zona de separare a sensurilor de trafic atunci când trebuie să navige:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în exteriorul unei scheme de separare a traficului.",
                "b) în interiorul unei scheme de separare a traficului.",
                "c) în interiorul unei benzi de separaţie."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "38. Cum trebuie să se angajeze o navă pentru intrarea sau ieşirea dintr-o schemă de separare a traficului?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sub un unghi drept faţă de direcţia generală a traficului.",
                "b) ca regulă generală pe la una din extremităţi,dar atunci când se angajează să intre sau să iasă,din orice parte,să facă manevra sub unghi cât mai mic faţă de direcţia traficului.",
                "c) prin zona de separare a traficului,dar cu aprobarea autorităţilor care supraveghează navigaţia în schema de separare a traficului."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "39. Cum trebuie să întretaie o navă benzile de separaţie, când este obligată să o facă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sub un unghi cât mai mic faţă de direcţia generală a traficului şi cu viteza redusă.",
                "b) sub un unghi cât mai mic faţă de direcţia generală a traficului şi cu viteză maximă.",
                "c) pe cât posibil perpendicular faţă de direcţia generală a traficului."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "40. Zonele de navigaţie costieră pot fi folosite pentru traficul costier?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în mod normal nu trebuie folosite pentru traficul direct, cu excepţia navelor mai mici de 20 m lungime şi a navelor cu vele.",
                "b) pot fi folosite de toate navele aparţinând ţării riverane.",
                "c) pot fi folosite de navele cu capacitate de manevră redusă."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "41. Când poate o navă să pătrundă într-o zonă de separare sau să taie o linie de separare?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) când condiţiile hidrometeorologice fac dificilă navigaţia în sensul general al traficului.",
                "b) în caz de urgenţă, pentru evitarea unui pericol imediat, sau pentru a pescui într-o zonă de separare.",
                "c) zona de separare nu va fi traversată în nici o situaţie."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "42. Cum trebuie să se navige în zone vecine cu extremităţile unei zone de separare a traficului?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se va naviga în direcţia generală a traficului.",
                "b) se vor semnaliza sonor şi vizual intenţiile de schimbare de drum.",
                "c) cu atenţie deosebită."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "43. Este permisă ancorarea în schemele de separare a traficului?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se va evita în măsura maximă a posibilului ancorarea atât în schema de separare, cât şi în zonele învecinate acesteia.",
                "b) se poate ancora, dar se vor da toate semnalele prevăzute în prezentele reguli.",
                "c) nu se poate ancora în nici o situaţie."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "44. Cum trebuie să navige navele care nu folosesc o schemă de separare a traficului?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să folosească zonele de navigaţie costieră.",
                "b) să se îndepărteze cât mai mult de zona de separare a traficului.",
                "c) să navige în apropiere, dar să nu intersecteze linia de separare."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "45. Care sunt navele exceptate de la prevederile regulii referitoare la navigaţie în schemele de separare a traficului?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navele cu capacitate de manevră redusă, angajate în manevra de menţinere a siguranţei navigaţiei.",
                "b) navele cu defecţiuni la motorul principal.",
                "c) navele cu avarii la cârmă."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "46. Ce navă trebuie să se abată din drumul navei ajunsă din urmă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nava care se află la o distanţă de 200 m.",
                "b) nava care se află la o distanţă de 100 m.",
                "c) nava care ajunge din urmă."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "47. Cum se comportă o navă care ajunge din urmă (depăşeşte) o altă navă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nava care ajunge din urmă o altă navă va avea prioritate.",
                "b) nava ajunsă din urmă va manevra astfel încât să-i permită navei care o depăşeşte deplasarea.",
                "c) orice navă care ajunge din urmă o altă navă trebuie să se abată din drumul navei ajunsă din urmă."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "48. Când se consideră că o navă ajunge din urmă altă navă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) când vine dintr-o direcţie mai mare de 22°5 dinapoia traversului celeilalte nave, astfel încât noaptea se vede numai lumina din pupa şi luminile din bordurile navei ajunsă din urmă.",
                "b) când vede lumina din pupa şi luminile din bordurile navei ajunsă din urmă.",
                "c) când vede lumina catargului pupa şi luminile din pupa."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "49. Cum trebuie să manevreze o navă care nu poate stabili cu siguranţă că ajunge din urmă altă navă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să se considere navă privilegiată şi şă-şi menţină viteza şi drumul.",
                "b) să se considere navă care ajunge din urmă şi să manevreze în consecinţă.",
                "c) să dea semnalele corespunzătoare şi după edificare să procedeze conform situaţiei."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "50. Cum trebuie să manevreze două nave cu vele care se apropie una de alta, astfel încât există pericolul de coliziune şi primesc vântul din borduri diferite?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nava care primeşte vântul din babord trebuie să se abată din drumul navei care primeşte vântul din tribord.",
                "b) nava care primeşte vântul din tribord trebuie să se abată din drumul navei care primeşte vântul din babord.",
                "c) nava care primeşte vântul din pupa trebuie să se abată din drumul navei care primeşte vântul din tribord."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "51. Cum trebuie să manevreze două nave cu vele care se apropie una de alta, astfel încât există pericolul de coliziune şi primesc vântul din acelaşi bord?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nava care o vede pe cealaltă prin babord trebuie să se abată din drumul celeilalte nave.",
                "b) nava care este în vânt se va abate din drumul navei de sub vânt.",
                "c) nava care o vede pe cealaltă prin tribord trebuie să se abată din drumul celeilalte nave."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "52. Care este manevra unei nave care nu este obligată să se abată din drumul altei nave?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) trebuie să-şi menţină drumul şi viteza.",
                "b) va schimba numai drumul, pentru a evita o situaţie periculoasă.",
                "c) va reduce viteza sau va stopa, pentru a nu crea situaţii periculoase."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "53. Când trebuie să manevreze nava care nu este obligată să se abată din drumul altei nave?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) indiferent de situaţie, nu se va abate niciodată din drumul altei nave.",
                "b) imediat ce i se pare evident faptul că nava care are obligaţia de a se abate din drumul său nu face manevra.",
                "c) când în urma observării relevmentului şi-a dat seama că există pericolul de coliziune."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "54. Din drumul căror nave trebuie să se abată o navă cu propulsie mecanică în marş?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navelor cu vele.",
                "b) velierelor care navigă numai cu maşina.",
                "c) velierelor care poartă la prova un semn conic negru, cu vârful în jos."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "55. Din drumul căror nave trebuie să se abată o navă cu vele în marş?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navelor cu propulsie mecanică cu viteză mică.",
                "b) navelor care nu sunt stăpâne pe manevra lor.",
                "c) navelor petroliere sau navelor care transportă gaze lichefiate."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "56. Din drumul căror nave trebuie să se abată o navă cu vele în marş?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navelor frigorifice cu viteză mare.",
                "b) navelor petroliere.",
                "c) navelor cu capacitate de manevră redusă."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "57. Din drumul căror nave trebuie să se abată o navă cu vele în marş?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navelor în curs de pescuit.",
                "b) traulelor aflate în marş spre zona de pescuit.",
                "c) navelor colectoare de peşte aflate în marş."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "58. Din drumul căror nave trebuie să se abată o navă stânjenită de pescajul său?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navelor cu vele.",
                "b) navelor nestăpâne pe manevra lor.",
                "c) navelor petrolier sau navelor care transportă gaze lichefiate."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "59. Căror nave li se aplică regulile de conducerea navelor pe vizibilitate redusă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navelor care navigă în interiorul zonelor de vizibiliate redusă şi numai una dintre ele nu o vede pe cealaltă.",
                "b) navelor care nu se văd una pe alta şi care navigă înlăuntrul sau în apropierea zonelor de vizibilitate redusă.",
                "c) navelor care navigă în interiorul sau în apropierea zonelor de vizibilitate redusă şi observă una la alta numai luminile de catarg."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "60. Cu ce viteză trebuie să navige o navă în condiţii de vizibilitate redusă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu viteză redusă şi veghe la prova.",
                "b) cu viteză economică, dar cu radarul în funcţiune şi cu o veghe corespunzătoare, pentru a evita pericolul de coliziune.",
                "c) cu o viteză de siguranţă adaptată împrejurărilor existente şi condiţiilor de vizibilitate redusă."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "61. Când se vor respecta regulile referitoare la \"lumini şi semne\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în marş ziua şi noaptea.",
                "b) pe orice vreme.",
                "c) în staţionare ziua şi noaptea."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "62. În ce perioadă sunt respectate regulile referitoare la lumini?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pe timpul nopţii.",
                "b) pe timpul nopţii şi pe vizibilitate redusă.",
                "c) de la apusul la răsăritul soarelui."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "63. Pe timpul zilei se vor respecta regulile cu privire la:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lumini.",
                "b) semne.",
                "c) lumini şi semne."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "64. Când mai pot fi purtate luminile prevăzute de reguli?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de la răsăritul la apusul soarelui, pe timp cu vizibilitate redusă, în toate împrejurările în care această măsură este necesară.",
                "b) când vizibilitatea este sub 3 Mm.",
                "c) în srâmtori, când vizibiliatea este redusă."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "65. Când se vor respecta regulile referitoare la semne?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în timpul crepusculului.",
                "b) pe timpul zilei.",
                "c) ziua sau noaptea, când sunt iluminate."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "66. Lumina albă aşezată deasupra axului longitudinal al navei, arătând o lumină neîntreruptă pe un arc de orizont de 22°5 astfel ca să arate 22°5 înapoia traversului fiecărui bord este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lumina de pupa.",
                "b) lumina de catarg.",
                "c) lumina de remorcaj."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "67. Lumină verde din tribord şi lumină roşie din babord, vizibile pe un arc de 112°5 adică de la prova până la 22°5 înapoia traversului, reprezintă ceea ce se înţelege prin expresia:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lumină de bord.",
                "b) lumină de pupa.",
                "c) lumină de remorcaj."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "68. Ce se înţelege prin expresia \"lumină de catarg\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) orice lumină albă instalată pe catargul unei nave la o înălţime prevăzută de normele din registru.",
                "b) orice lumină albă vizibilă pe tot orizontul.",
                "c) o lumină albă aşezată deasupra axului longitudinal al navei, arătând o lumină neîntreruptă pe un arc de orizont de 225°, astfel ca să arate 22°5 înapoia traversului fiecărui bord."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "69. Ce se înţelege prin expresia \"lumină de bord\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lumină verde din tribord şi lumină roşie din babord, vizibile pe un arc de 112°5, adică la prova până la 22°5 înapoia traversului.",
                "b) lumină albă din borduri, de la scările de acces.",
                "c) lumină albă de la scările exterioare."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "70. Lumina albă aşezată cât mai aproape posibil în pupa, arătând o lumină neîntreruptă pe un arc de 135° câte 67°5 în fieare bord este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lumina de ancoră pupa.",
                "b) lumina de remorcaj.",
                "c) lumina de pupa."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "71. Ce se înţelege prin expresia \"lumină de pupa\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o lumină albă instalată la pupa unei nave.",
                "b) o lumină aşezată cât mai aproape posibil în pupa, arătând o lumină neîntreruptă pe un arc de 135°, câte 67°5 în fiecare bord.",
                "c) o lumină albă instalată la pupa, care arată ca o lumină întreruptă pe un arc de cerc de 135°, câte 67°5 în fiecare bord."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "72. Lumina galbenă aşezată cât mai aproape posibil în pupa arătând o lumină de 135°, câte 67°5 în fiecare bord este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lumina de pupa.",
                "b) lumina de remorcaj.",
                "c) lumina de ancoră pupa."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "73. Trei lumini în poziţie verticală din care luminile de sus şi de jos roşii şi lumina din mijloc albă sunt luminile purtate de o navă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu capacitate de manevră redusă când nu este în marş.",
                "b) nestăpână pe manevra sa.",
                "c) stânjenită de pescajul ei când nu este în marş."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "74. Ce se înţelege prin expresia \"lumină de remorcaj\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o lumină albă aşezată deasupra luminii de la pupa după care se guvernează în timpul remorcajului.",
                "b) o lumină galbenă neîntreruptă vizibilă la 360°.",
                "c) o lumină galbenă aşezată cât mai aproape posibil de pupa, arătând o lumină neîntreruptă pe un arc de cerc de 135°, câte 67°5 în fiecare bord."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "75. Luminile roşu-alb-roşu dispuse pe verticală, lumina de ancoră de la pupa sunt luminile purtate de o navă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nestăpână pe manevră la ancoră.",
                "b) cu capacitate de manevră redusă la ancoră.",
                "c) stânjenită de pescajul ei la ancoră."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "76. Lumina neîntreruptă pe un arc de orizont de 360° este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lumina de catarg.",
                "b) lumină cu sclipiri regulate.",
                "c) lumină vizibilă pe întreg orizontul."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "77. Trei semne suprapuse din care semnul superior şi inferior câte o bulă, iar cel din mijloc un bicon sunt semnele purtate de o navă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nestăpână pe manevra sa.",
                "b) stânjenită de pescajul ei.",
                "c) cu capacitate de manevră redusă."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "78. Ce se înţelege prin expresia \"lumină vizibilă pe întreg orizontul\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lumină neîntreruptă pe un arc de de orizont de 360°",
                "b) lumină neîntreruptă vizibilă la prova şi în borduri.",
                "c) lumină neîntreruptă vizibilă pe un arc de orizont de 180°"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "79. O lumină cu sclipiri regulate a cărei frecvenţă este de 120 sclipiri pe minut sau mai mult, reprezintă ceea ce se înţelege prin expresia:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lumină de bord.",
                "b) lumină cu sclipiri.",
                "c) lumină de remorcaj."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "80. O bulă la prova şi trei semne dispuse vertical, dintre care semnul superior şi inferior bule şi cel din mijloc bicon, montate în locul cel mai vizibil sunt semnele purtate de o navă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu capacitate de manevră redusă la ancoră.",
                "b) stânjenită de pescajul ei la ancoră.",
                "c) nestăpână pe manevră la ancoră."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "81. Ce se înţelege prin expresia \"lumină cu sclipiri\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o lumină cu sclipiri regulate cu frecvenţa de 60 sclipiri pe minut.",
                "b) o lumină cu sclipiri regulate cu frecvenţa de 120 sclipiri pe minut sau mai mult.",
                "c) o lumină cu sclipiri regulate foarte repezi."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "82. La ce distanţă trebuie să se vadă luminile de la catarge pentru navele cu lungimea între 12 şi 20 m?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 1-2 Mm.",
                "b) 2 Mm.",
                "c) 3 Mm."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "83. La ce distanţă trebuie să se vadă luminile de la catarge pentru navele cu lungimea mai mică de 12 m?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 3 Mm.",
                "b) 2 Mm.",
                "c) 1 Mm."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "84. Un cilindru negru reprezintă semnul purtat de o navă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) stânjenită de pescajul său.",
                "b) cu capacitate de manevră redusă.",
                "c) nestăpână pe manevră"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "85. La ce distanţă trebuie să se vadă luminile din borduri pentru navele cu o lungime între 12 şi 50 m?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 3 Mm.",
                "b) 2 Mm.",
                "c) 1,5 Mm."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "86. La ce distanţă trebuie să se vadă luminile din borduri pentru navele cu o lungime mai mică de 12 m?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 2 Mm.",
                "b) 0,5 Mm.",
                "c) 1 Mm."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "87. La ce distanţă trebuie să se vadă lumina din pupa pentru navele cu o lungime între 12 şi 50 m?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 3 Mm.",
                "b) 2 Mm.",
                "c) 1 Mm."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "88. La ce distanţă trebuie să se vadă lumina din pupa pentru navele cu o lungime mai mică de 12 m?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 3 Mm.",
                "b) 1,5 Mm.",
                "c) 2 Mm."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "89. La ce distanţă trebuie să se vadă lumina de remorcaj pentru navele cu o lungime mai mare de 50 m?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 3 Mm.",
                "b) 4 Mm.",
                "c) 3,5 Mm."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "90. La ce distanţă trebuie să se vadă lumina de remorcaj pentru navele cu o lungime între 12 şi 50 m?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 3 Mm.",
                "b) 2 Mm.",
                "c) 5 Mm."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "91. La ce distanţă trebuie să se vadă lumina de remorcaj pentru navele cu o lungime mai mică de 12 m?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 1 Mm.",
                "b) 3 Mm.",
                "c) 2 Mm."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "92. La 2 Mm se văd luminile albe, roşii, verzi sau galbene pe întreg orizontul la navele:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu lungimea mai mare de 50 m.",
                "b) cu lungimea mai mică de 100 m.",
                "c) cu lungimea între 12 şi 20 m."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "93. La ce distanţă trebuie să se vadă lumina albă, roşie, verde sau galbenă vizibilă pe întreg orizontul, pentru navele cu lungimea între 12 şi 50 m?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 3 Mm.",
                "b) 2 Mm.",
                "c) 1 Mm."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "94. Ce lumini trebuie să poarte o navă cu pernă de aer în exploatare fără pescaj?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) aceleaşi lumini ca o navă cu propulsie mecanică în marş.",
                "b) o lumină galbenă cu sclipiri vizibile pe tot orizontul.",
                "c) luminile unei nave cu propulsie mecanică în marş plus o lumină galbenă cu sclipiri vizibilă pe tot orizontul."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "95. Ce lumini trebuie să poarte o navă cu propulsie mecanică în marş cu lungimea mai mare de 7 m şi a cărei viteză depăşeşte 7 Nd?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o lumină albă vizibilă peste tot orizontul şi dacă este posibil şi luminile din borduri.",
                "b) luminile din borduri.",
                "c) o lumină albă care poate fi ridicată la nevoie."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "96. La ce distanţă trebuie să se vadă lumina albă vizibilă pe tot orizontul, a unei nave sau obiect de formă nedefinită, parţial în imersiune, care este remorcat?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 3 Mm.",
                "b) 2Mm.",
                "c) 1 Mm."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "97. Ce lumini trebuie să poarte obiectele sau navele remorcate, altele decât cele cu forma nedefinită?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) luminile de catarg şi lumina de pupa.",
                "b) luminile din borduri şi lumina de pupa.",
                "c) luminile de remorcher şi lumina de pupa."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "98. Ce lumini trebuie să poarte o navă împinsă înainte când formează o singură unitate?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) trebuie să poarte la extremitatea prova luminile din borduri.",
                "b) lumina de catarg şi luminile din borduri.",
                "c) lumină de catarg şi lumină de pupa."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "99. Ce lumini tebuie să poarte o navă remorcată la ureche?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) luminile de catarg şi lumina de pupa.",
                "b) lumina de pupa şi luminile din borduri la extremitatea prova.",
                "c) luminile de borduri la extremitatea prova."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "100. Luminile din borduri şi lumina din pupa sunt luminile pe care le poartă o navă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în seviciul de pilotaj şi este în marş.",
                "b) cu vele când este la ancoră.",
                "c) cu vele în marş."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "101. Ce lumini poartă o navă cu vele în marş?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) luminile din borduri.",
                "b) luminile de catarg şi luminile din borduri.",
                "c) luminile din borduri şi lumina de pupa."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "102. Luminile din borduri şi lumina din pupa, reunite într-un felinar este purtat de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o navă cu vele mai mică de 7 m, în marş.",
                "b) o navă cu rame.",
                "c) o navă cu vele la ancoră."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "103. Ce lumini poartă o navă cu vele în marş, mai mică de 20 m?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) luminile din borduri şi lumina din pupa, pe care le poate reuni într-un felinar.",
                "b) luminile din borduri.",
                "c) o lumină albă pe care să o arate la nevoie."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "104. La măr sau în partea superioară a catargului, în locul cel mai vizibil, trebuie să poarte felinarul combinat o navă cu vele în marş, cu o lungime mai mică de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 30 m.",
                "b) 20 m.",
                "c) 15 m."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "105. Unde trebuie să poarte felinarul combinat o navă cu vele în marş mai mică de 20 m?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) poate să-l ţină oriunde şi să-l arate numai la nevoie.",
                "b) la măr sau la partea superioară a catargului, în locul cel mai vizibil.",
                "c) la bastonul prova."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "106. Care sunt luminile suplimentare pe care le poate purta o navă cu vele în marş?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la măr o lumină verde vizibilă pe tot orizontul.",
                "b) la măr o lumină roşie vizibilă pe tot orizontul.",
                "c) la măr sau la partea superioară a catargului o lumină roişie deasupra unei lumini verzi, vizibile pe tot orizontul."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "107. Nava care trebuie să fie gata să arate în orice moment o lanternă electrică sau un felinar aprins cu o lumină albă este nava cu vele, în marş, cu o lungime mai mică de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 15 m.",
                "b) 10 m.",
                "c) 7 m."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "108. Ce lumini poartă o navă cu vele, mai mică de 7 m, în marş?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) trebuie să fie gata să arate în orice moment o lanternă electrică sau un felinar aprins cu o lumină albă.",
                "b) luminile din borduri.",
                "c) o lumină albă la catarg."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "109. Ce lumini trebuie să poarte o navă cu rame?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o lampă albastră care să poată fi arătată oricând.",
                "b) o lumină roşie.",
                "c) dacă nu poartă luminile unei nave cu vele, să fie pregătiră să arate o lanternă electrică sau un felinar cu lumină albă."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "110. La prova, în locul cel mai vizibil, un con cu vârful în jos este semnul purtat pe timp de zi de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o navă care pescuieşte şi ale cărei unelte se întind pe o distanţă orizontală mai mare de 150 m.",
                "b) o navă care navigă în acelaşi timp cu vele şi cu ajutorul unui aparat propulsor.",
                "c) o navă sau obiect remorcat care este parţial în imersiune şi greu de observat."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "111. Ce semn trebuie să poarte o navă care navigă în acelaşi timp cu vele şi cu ajutorul unui aparat propulsor?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la prova, în locul cel mai vizibil, un con cu vârful în jos.",
                "b) un bicon în locul cel mai vizibil.",
                "c) două conuri negre vârf la vârf."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "112. Două lumini suprapuse, vizibile pe tot orizontul, lumina superioară verde şi ce inferioară albă, o lumină de catarg aşezată la o înălţime mai mare decât lumina verde şi înapoia acesteia sunt luminile purtate de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o navă angajată în operaţiuni de deminare.",
                "b) o navă cu vele în marş.",
                "c) o navă care traulează şi nu este în marş."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "113. Ce semne poartă o navă ancorată?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o bulă ridicată la prova.",
                "b) un bicon instalat la prova.",
                "c) un con negru instalat la prova."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "114. Unde trebuie instalate semnele şi luminile navelor eşuate?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la prova.",
                "b) la catargul pupa.",
                "c) în locul cel mai vizibil."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "115. Când nu sunt obligate navele mai mici de 7 m lungime să poarte lumini de navă ancorată?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) când sunt la ancoră dar nu într-un canal navigabil îngust, pase de intrare în port sau rade de ancorare.",
                "b) când sunt ancorate într-un bazin portuar.",
                "c) când sunt la ancoră şi în radă."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "116. Căror nave eşuate nu li se cere să poarte luminile şi semnele speciale de navă eşuată?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nave cu lungime mai mică de 7 m.",
                "b) nave cu lungime mai mică de 15 m.",
                "c) nave cu lungime mai mică de 12 m."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "117. Ce este \"sunetul scurt\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un sunet cu o durată de 2-3 secunde, emis de o navă.",
                "b) un sunet emis de o navă propulsată, în marş, cu o durată mică, sub o secundă.",
                "c) un sunet a cărui durată este de aproximativ o secundă."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "118. Ce se înţelege prin expresia \"sunet lung\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un sunet a cărui durată este de 4-6 secunde.",
                "b) un sunet emis de o navă propulsată, în marş, cu o durată de peste 6 secunde.",
                "c) un sunet sonor emis de o navă cu o durată de 2-3 secunde."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "119. Ce echipament de semnalizare sonoră trebuie să aibă o navă cu lungimea între 12 şi 100m?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un singur fluier în mijlocul navei.",
                "b) un clopot la prova sau pupa navei.",
                "c) un fluier şi un clopot."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "120. Ce echipament de semnalizare sonoră trebuie să aibă o navă sub 12 m lungime?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navele sub 12 m lungime nu sunt obligate să aibă echipament de semnalizare sonoră.",
                "b) navele sub 12 m lungime sunt obligate să aibă un fluier şi un clopot la prova.",
                "c) navele sub 12 m lungime nu sunt obligate să aibă la bord echipamentul de semnalizare prescris, în lipsa lui să fie dotate cu un alt mijloc de emitere a unui semnal sonor eficace."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "121. Când se emit semnalele sonore de manevră?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în orice situaţii.",
                "b) când navele se văd unele pe altele.",
                "c) pe timp de vizibilitate redusă."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "122. Ce semnal sonor se emite pentru indicarea manevrei \"vin la tribord\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un sunet scurt.",
                "b) un sunet scurt, urmat de un sunet lung.",
                "c) două sunete lungi, urmate de unul scurt."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "123. Ce semnal sonor se emite pentru indicarea manevrei \"vin la babord\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un sunet lung şi două scurte.",
                "b) două sunete scurte.",
                "c) două sunete lungi, urmate de două sunete scurte."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "124. Ce semnal sonor se emite pentru indicarea manevrei \"am maşina înapoi\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un sunet lung şi trei sunete scurte.",
                "b) trei sunete scurte precedate şi urmate de un sunet lung.",
                "c) trei sunete scurte."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "125. Cu ce se pot completa semnalele sonore emise cu fluierul, pentru a indica o manevră ce se execută?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu semnale luminoase.",
                "b) cu orice alte semnale.",
                "c) cu una sau două bule negre ridicate la catarg."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "126. La ce interval de timp se pot da semnalele necesare luminoase pentru repetarea manevrei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la cel puţin 10 secunde.",
                "b) după minim un minut.",
                "c) de câte ori este nevoie."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "127. Ce semnale dă o navă care îşi dă acordul în legătură cu manevra de depăşire pe care urmează să o facă altă navă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un sunet lung şi 5 sunete scurte.",
                "b) un sunet lung, un sunet scurt, un sunet lung şi unul scurt (litera C)",
                "c) un sunet scurt pentru tribord şi 2 sunete scurte pentru babord."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "128. Când se emit semnalele sonore pentru vizibilitate redusă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) numai ziua, pe vizibilitate redusă.",
                "b) noaptea pe timp de ceaţă.",
                "c) atât ziua cât şi noaptea, pe vizibilitate redusă."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "129. Când se emit semnalele sonore pe vizibilitate redusă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) înlăuntrul sau în apropierea zonei în care vizibilitatea este redusă.",
                "b) înlăuntrul unei zone în care vizibilitatea este redusă",
                "c) numai pe timp de ceaţă."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "130. Ce semnal sonor emite o navă cu capacitatea de manevră redusă pe vizibilitate redusă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un sunet lung urmat de trei sunete scurte la intervale de 2 minute.",
                "b) 3 sunete scurte precedate şi urmate de un sunet lung, la intervale de 2 minute.",
                "c) un sunete lung urmat de 2 sunete scurte la intervale nu mai mari de 2 minute."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "131. Ce semnale sonore vor emite navele stânjenite de pescajul lor pe vizibilitate redusă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un sunet lung urmat de două sunete scurte, la intervale nu mai mari de 2 minute.",
                "b) un sunet lung precedat şi urmat de un sunet scurt la intervale de un minut.",
                "c) 5 sunete scurte la intervale de 2 minute."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "132. Ce semnale sonore emite o navă cu vele pe vizibilitate redusă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un sunet lung dat cu sirena, la intervale de un minut.",
                "b) 4 sunete scurte la intervale de două minute.",
                "c) un sunet lung urmat de 2 sunete scurte, la intervale ce nu vor fi mai mari de 2 minute."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "133. Ce obligaţii are o navă mai mică de12 m, pe vizibilitate redusă, în cazul în care nu poate emite semnale prescrise de Regulament?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să emită cu fluierul un semnal sonor format din 5 sunete la interval de un minut.",
                "b) să emită un semnal sonor eficace la intervale care să nu depăşească 2 minute.",
                "c) să emită cu gongul bătăi repezi la interval de maxim un minut."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "134. Care este semnalul de pericol din Codul Internaţional de Semnale?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) \"N.C\"",
                "b) \"P.\"",
                "c) \"O.\""
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "135. Care poate fi considerat semnal de pericol?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un pavilion având deasupra sau dedesubt o bulă sau un obiect asemănător.",
                "b) 3 bule negre vertical.",
                "c) un pavilion roşu (B)."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "136. Care poate fi considerat semnal de pericol?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) fuzee sau facle de mână care produc lumină roşie.",
                "b) fuzee sau facle de mână care produc lumină verde.",
                "c) fuzee sau facle de mână care produc lumină albă strălucitoare."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "137. Ce este semnalul de pericol dat cu braţele?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mişcări lente repetate cu braţele, descriind cercuri deasupra capului.",
                "b) ridicarea ambelor braţe vertical deasupra capului.",
                "c) mişcări lente şi repetate de sus în jos a braţelor întinse lateral."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "138. Care este semnalul de alarmă radiotelefonică?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un semnal bitonal continuu.",
                "b) un semnal de ton continuu.",
                "c) un semnal compus din tonuri scurte, continuu."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "139. Ce nave pot folosi zonele de navigaţie de trafic costier?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navele cu o lungime mai mică de 20 m, navele cu vele şi navele angajate în operaţiuni de pescuit.",
                "b) navele ce aparţin ţării riverane.",
                "c) navele cu capacitate de manevră redusă."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "140. Când pot folosi navele zonele de navigaţie de trafic costier?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pentru evitarea unui pericol evident.",
                "b) când sunt considerate nave privilegiate.",
                "c) când sunt nave stânjenite de pescajul lor."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "141. Ce semnificaţie au semnele aprobate transmise prin sisteme de radiocomunicaţii?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sunt considerate semnale de pericol.",
                "b) sunt considerate semnale de test.",
                "c) sunt considerate semnale de avertizare."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "142. Ce semnificaţie au semnalele transmise de SART-urile mijlocelor de salvare?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sunt considerate semnale de atragere a atenţiei.",
                "b) sunt considerate semnale de avertizare.",
                "c) sunt considerate semnale de pericol."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-COLREG",
            "difficulty": 1
        },
        {
            "question": "143. Scara numerică a unei hărți este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Raportul dintre lungimea și lățimea hărții",
                "b) Un număr de catalog",
                "c) Raportul dintre lungimea unitară de pe Pământ și corespondentul pe hartă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "144. În emisfera vestică, dacă nava se deplasează spre vest",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de sosire este mai mică decât latitudinea punctului de sosire",
                "b) longitudinea punctului de plecare este mai mică decât longitudinea punctului de sosire",
                "c) longitudinea punctului de plecare este mai mare decât longitudinea punctului de sosire"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "145. Temperatura apei de mare se exprimă în",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Milibari",
                "b) grade Celsius",
                "c) milimetri coloană de mercur"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "146. Corespunzător sensului convențional de balizaj de la larg la uscat, în regiunea B, marcajele laterale au următoarele lumini",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tribord-verde, babord-roșu",
                "b) tribord-albă fixa, babord- albă cu sclipiri",
                "c) tribord-roșu, babord-verde"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "147. Drumul giro al navei este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Unghiul din planul orizontului adevărat măsurat de la axul prova al navei până la direcția de vizare la un reper costier",
                "b) Unghiul din planul orizontului adevărat măsurat de la direcția nord compas până la axul prova al navei",
                "c) Unghiul din planul orizontului adevărat măsurat de la direcția nord giro până la axul prova al navei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "148. Relevmentul prova la un reper costier este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Unghiul din planul orizontului adevărat măsurat de la axul prova al navei până la direcția de vizare la reperul costier",
                "b) Unghiul din planul orizontului adevărat măsurat de la direcția nord adevărat până la linia de vizare la reperul costier",
                "c) Unghiul din planul orizontului adevărat măsurat de la direcția nord magnetic până la axul prova al navei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "149. Latitudinea geografică este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Arcul de ecuator măsurat de la meridianul Greenwich până la meridianul locului",
                "b) Arcul de paralel măsurat de la meridianul Greenwich până la meridianul locului",
                "c) Arcul de meridian măsurat de la ecuatorul terestru până la paralelul locului"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "150. In emisfera estică, dacă nava se deplasează spre vest",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de sosire este mai mică decât latitudinea punctului de sosire",
                "b) longitudinea punctului de sosire este mai mică decât longitudinea punctului de plecare",
                "c) longitudinea punctului de sosire este mai mare decât longitudinea punctului de plecare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "151. Dacă vântul bate dinaintea traversului acesta produce",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) creșterea vitezei și derivă de vânt",
                "b) numai creșterea vitezei",
                "c) micșorarea vitezei și derivă de vânt"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "152. Relevmentul compas la un reper costier este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Unghiul din planul orizontului adevărat măsurat de la axul prova al navei până la direcția de vizare la reperul costier",
                "b) Unghiul din planul orizontului adevărat măsurat de la direcția nord compas până la linia de vizare la reperul costier",
                "c) Unghiul din planul orizontului adevărat măsurat de la direcția nord magnetic până la axul prova al navei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "153. Longitudinea geografică este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Arcul de ecuator măsurat de la meridianul Greenwich până la meridianul locului",
                "b) Arcul de paralel măsurat de la meridianul Greenwich până la meridianul locului",
                "c) Arcul de meridian măsurat de la ecuatorul terestru până la paralelul locului"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "155. În emisfera sudica, dacă nava se deplasează spre Nord",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de plecare este mai mică decât latitudinea punctului de sosire",
                "b) latitudinea punctului de plecare este mai mare decât latitudinea punctului de sosire",
                "c) longitudinea punctului de plecare este mai mică decât longitudinea punctului de sosire"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "156. Acul magnetic al compasului magnetic de la bordul navei se orientează pe direcția",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nord adevărat",
                "b) Nord giro",
                "c) Nord compas"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "157. Marcajele laterale din sistemul de balizaj semnalizează",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Limitele laterale ale unui pericol de navigație",
                "b) Limitele laterale ale unei serii de pericole de navigație",
                "c) Limitele laterale ale șenalului navigabil"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "158. Drumul magnetic al navei este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Unghiul din planul orizontului adevărat măsurat de la axul prova al navei până la direcția de vizare la un reper costier",
                "b) Unghiul din planul orizontului adevărat măsurat de la direcția nord compas până la axul prova al navei",
                "c) Unghiul din planul orizontului adevărat măsurat de la direcția nord magnetic până la axul prova al nave"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "159. Relevmentul magnetic la un reper costier este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Unghiul din planul orizontului adevărat măsurat de la axul prova al navei până la direcția de vizare la reperul costier",
                "b) Unghiul din planul orizontului adevărat măsurat de la direcția nord adevărat până la linia de vizare la reperul costier",
                "c) Unghiul din planul orizontului adevărat măsurat de la direcția nord magnetic până la linia de vizare la reperul costier"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "160. Polii geografici sunt",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Cele două puncte în care axa de rotație intersectează suprafața Pământului",
                "b) Punctele în care linia ce trece prin centrul Pământului și punctul navei intersectează suprafața Pământului",
                "c) Punctele în care linia ce trece prin centrul Pământului și prin observatorul astronomic de la Greenwich intersectează suprafața Pământului"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "161. Adâncimea apei se măsoară cu",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lochul",
                "b) sonda",
                "c) barometrul"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "162. Reperele costiere utilizate pentru determinarea punctului navei pot fi",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) geamanduri, balize, scondri",
                "b) alte nave aflate la ancoră",
                "c) faruri"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "163. Drumul adevărat al navei este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Unghiul din planul orizontului adevărat măsurat de la axul prova al navei până la direcția de vizare la un reper costier",
                "b) Unghiul din planul orizontului adevărat măsurat de la direcția nord adevărat până la axul prova al navei",
                "c) Unghiul din planul orizontului adevărat măsurat de la direcția nord compas până la axul prova al navei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "164. Dacă vântul bate din travers acesta produce",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) creșterea vitezei și derivă de vânt",
                "b) doar creșterea vitezei",
                "c) derivă de vânt"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "165. Lumina alternativă a unui far are următoarea semnificație",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) intensitatea luminii este variabilă",
                "b) lumina fixă combinata cu intensificare de lumina",
                "c) culori diferite în sectoare strict delimitate"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "166. Longitudinea geografică este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Arcul de ecuator măsurat de la meridianul Greenwich până la meridianul locului",
                "b) Arcul de paralel măsurat de la meridianul Greenwich până la meridianul locului",
                "c) Arcul de meridian măsurat de la ecuatorul terestru până la paralelul locului"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "168. Dacă vântul bate din prova tribord acesta produce",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) micșorarea vitezei și derivă de vânt la tribord",
                "b) derivă de vânt la babord",
                "c) micșorarea vitezei și derivă de vânt la babord"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "169. Lumina unui far în izofază are următoarea semnificație",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) durata de lumina este egală cu durata de întuneric",
                "b) intensitatea luminii este constanta",
                "c) lumina fixă este combinata cu o intensificare de lumina"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "170. Drumul compas al navei este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) unghiul din planul orizontului adevărat măsurat de la axul prova al navei până la direcția de vizare la un reper costier",
                "b) unghiul din planul orizontului adevărat măsurat de la direcția nord compas până la axul prova al navei",
                "c) unghiul din planul orizontului adevărat măsurat de la direcția nord magnetic până la axul prova al navei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "171. Harta marină este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o hartă tematică care figurează aspecte detaliate ale întinderilor de apă de pe o anumită suprafață a scoarței terestre",
                "b) o harta geografică a unei porțiuni din suprafața Pământului care conține mări și oceane",
                "c) este o reprezentare în plan, convențională, micșorată și generalizată a oceanului planetar"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "172. În emisfera nordică, dacă nava se deplasează spre Nord",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de plecare este mai mică decât latitudinea punctului de sosire",
                "b) latitudinea punctului de plecare este mai mare decât latitudinea punctului de sosire",
                "c) longitudinea punctului de plecare este mai mică decât longitudinea punctului de sosire"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "173. Relevmentul adevărat la un reper costier este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Unghiul din planul orizontului adevărat măsurat de la axul prova al navei până la direcția de vizare la reperul costier",
                "b) Unghiul din planul orizontului adevărat măsurat de la direcția nord adevărat până la linia de vizare la reperul costier",
                "c) Unghiul din planul orizontului adevărat măsurat de la direcția nord magnetic până la axul prova al navei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "174. Poziția navei se poate determina, printre altele, prin măsurători de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) temperatură",
                "b) relevmente",
                "c) salinitate"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "175. Linia de credință a compasului magnetic de la bord materializează",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Direcția nord magnetic",
                "b) Axul longitudinal al navei",
                "c) Direcția nord compas"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "176. Viteza ambarcațiunii se măsoară cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sonda;",
                "b) barometrul;",
                "c) lochul."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "177. Adâncimea apei se măsoară cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lochul;",
                "b) sonda;",
                "c) barometrul."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "178. Dacă vântul bate dinaintea traversului acesta produce:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) creșterea vitezei și derivă de vânt;",
                "b) numai creșterea vitezei;",
                "c) micșorarea vitezei și derivă de vânt."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "179. Dacă vântul bate din travers acesta produce:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) creșterea vitezei și derivă de vânt;",
                "b) doar creșterea vitezei;",
                "c) derivă de vânt."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "180. Dacă vântul bate din prova tribord acesta produce:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) micșorarea vitezei și derivă de vânt la tribord;",
                "b) derivă de vânt la babord;",
                "c) micșorarea vitezei și derivă de vânt la babord."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "181. Temperatura apei de mare se exprima in:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) milibari;",
                "b) grade Celsius;",
                "c) milimetri coloană de mercur."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "182. Acul magnetic al compasului magnetic de la bordul ambarcațiunii se orientează pe direcția:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nord adevărat;",
                "b) Nord giro;",
                "c) Nord compas."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "183. Cele mai sigure repere costiere utilizate pentru determinarea punctului ambarcațiunii sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) geamanduri, balize, scondri;",
                "b) orice construcție de la coasta;",
                "c) faruri de aterizare."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "184. Linia de credința a compasului magnetic de la bord materializează:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) direcția Nord magnetic;",
                "b) axul longitudinal al ambarcațiunii;",
                "c) direcția Nord compas."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "185. Lumina unui far în izofaza are următoarea semnificație:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) durata de lumină este egală cu durata de întuneric;",
                "b) intensitatea luminii este constanta;",
                "c) lumina fixă este combinata cu o intensificare de lumina."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "186. Corpul balizei marcajului cardinal de Vest este piturat în dungi orizontale dispuse de sus în jos astfel:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) galben-negru-galben;",
                "b) negru-galben-negru;",
                "c) negru-galben."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "187. Corpul balizei marcajului cardinal de Nord este piturat în dungi orizontale dispuse de sus în jos astfel:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) negru-galben-negru;",
                "b) galben-negru-galben;",
                "c) negru-galben."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "188. Corpul balizei marcajului cardinal de Est este piturat în dungi orizontale dispuse de sus în jos astfel:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) negru-galben-negru;",
                "b) galben-negru-galben;",
                "c) negru-galben."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "189. Marcajul lateral de babord din regiunea A are ca semn de vârf:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un con negru cu vârful în sus;",
                "b) un cilindru verde:",
                "c) un cilindru roșu."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "190. Marcajul lateral de tribord din regiunea A are ca semn de vârf:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Un con verde cu vârful în sus;",
                "b) un cilindru verde;",
                "c) un cilindru roșu."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "191. Marcajul de pericol izolat are ca semn de vârf:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un con roșu cu vârful în sus;",
                "b) o sferă de culoare roșie;",
                "c) doua bule suprapuse de culoare neagra."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "192. Regula \"verde la tribord- roșu la babord\" valabila în regiunea A de balizaj se aplica marcajelor laterale astfel:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) in sensul de la coasta către larg;",
                "b) in sensul de larg către coastă;",
                "c) este de competenta guvernelor statelor riverane."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "193. Conducătorul de ambarcațiune vede pe timp de noapte în prova tribord un marcaj care emite un grup de doua sclipiri albe care se repeta regulat. Aceasta este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un semn de ape sigure;",
                "b) un semn de pericol izolat;",
                "c) un semn de vest."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "194. Conducătorul de ambarcațiune vede pe timp de noapte în prova babord un marcaj care emite un grup de doua sclipiri albe care se repeta regulat. Aceasta este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un semn de ape sigure;",
                "b) un semn de pericol izolat;",
                "c) un semn de est."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "195. Conducătorul de ambarcațiune vede pe timp de noapte în prova un marcaj care emite un grup de noua sclipiri albe care se repeta regulat. Aceasta este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un semn de ape sigure;",
                "b) un semn de pericol izolat;",
                "c) un semn de vest."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "196. Conducătorul de ambarcațiune vede pe timp de noapte în prova un marcaj care emite un grup de noua sclipiri albe care se repeta regulat. Aceasta este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un semn de ape sigure;",
                "b) un semn de vest;",
                "c) un semn de pericol izolat."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "197. Conducătorul de ambarcațiune vede pe timp de noapte în prova babord un marcaj care emite un grup de doua sclipiri albe care se repetă regulat. Aceasta este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un semn special;",
                "b) un semn de pericol izolat;",
                "c) un semn de vest."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "198. Cartul N este un cart:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) intercardinal;",
                "b) cardinal;",
                "c) inter-intercardinal;"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "199. Cartul SW este un cart:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) intercardinal;",
                "b) cardinal;",
                "c) inter-intercardinal;"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "200. Cartul SSE este un cart:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) intercardinal;",
                "b) cardinal;",
                "c) inter-intercardinal;"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "201. Cartul E la N este un cart:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) intercardinal;",
                "b) inter- intercadinal;",
                "c) intermediar"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "202. Drumul adevărat al ambarcațiunii este egal cu 090 grade; rezulta ca ambarcațiunea se deplasează către:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Vest;",
                "b) Est;",
                "c) Sud;"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "203. Drumul adevărat al ambarcațiunii este egal cu 000 grade; rezulta ca ambarcațiunea se deplasează către:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nord",
                "b) Est;",
                "c) Sud;"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "204. Drumul adevărat al ambarcațiunii este egal cu 180 grade; rezulta ca ambarcațiunea se deplasează către:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Vest;",
                "b) Est;",
                "c) Sud;"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "205. Drumul adevărat al ambarcațiunii este egal cu 270 grade; rezulta ca ambarcațiunea se deplasează către:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Vest;",
                "b) Est;",
                "c) Sud;"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "206. Drumul compas al ambarcațiunii se afla cuprins în cadranul NE de orizont. Care din următoarele valori de drum compas este corectă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Dc = 212 grade;",
                "b) Dc = 034 grade;",
                "c) Dc = 328 grade."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "207. Drumul compas al ambarcațiunii se afla cuprins în cadranul SE de orizont. Care din următoarele valori de drum compas este corectă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Dc = 112 grade;",
                "b) Dc = 034 grade;",
                "c) Dc = 328 grade."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "208. Drumul compas al ambarcațiunii se afla cuprins în cadranul SW de orizont. Care din următoarele valori de drum compas este corectă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Dc = 102 grade;",
                "b) Dc = 234 grade;",
                "c) Dc = 328 grade."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "209. Drumul compas al ambarcațiunii se afla cuprins în cadranul NW de orizont. Care din următoarele valori de drum compas este corectă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Dc = 102 grade;",
                "b) Dc = 234 grade;",
                "c) Dc = 328 grade."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Navigatie",
            "difficulty": 1
        },
        {
            "question": "210. Piesa de rezistenta situata în extremitatea prova , constituind o prelungire a chilei , se numește",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) contractilă",
                "b) etravă",
                "c) carlingă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "211. Ce reprezintă un cui de strapazan?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un cui de lemn folosit la asamblarea pieselor de rezistenta",
                "b) un cui de lemn bătut în marginea bordajului , vertical de care se prinde rama",
                "c) un cui de lemn , așezat la prova de care se leagă barca"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "212. La ce folosește podul în cazul zalei de ancora",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) zalele de ancora nu au pod",
                "b) la ghidare pe nara de ancora",
                "c) mărește rezistenta la întindere și împiedica încurcarea"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "213. Barbetele sunt bucăți de parâma fixate la prova și pupa bărcii și servesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pentru amaraj",
                "b) in cazul unei persoane căzută peste bord",
                "c) pentru legare sau remorcat"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "214. Parâma obținută din răsucirea a trei șuvițe se numește",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) parâmă simplă sau lanƫanã",
                "b) parâmă simplă sau garlin",
                "c) parâmă simplă sau cordon"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "215. Apărătoarele gașelor mici la parâme se numesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) guardaman",
                "b) rodanțe",
                "c) binte"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "216. Babalele sunt piese metalice din fonta sau otel , simple sau duble și servesc pentru",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) întărirea structurii de rezistenta a navei",
                "b) ancoraj",
                "c) luarea voltelor cu parâme"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "217. La navele mici locul babalelor poate fi luat de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) trancheti",
                "b) tacheți",
                "c) turnicheti"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "218. Ce este operațiunea de matisire?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) împreunarea a doua capete de parâma sau realizarea unei gașe",
                "b) trecerea de la o parâma mai groasa spre una mai subțire",
                "c) sporirea rezistentei la rupere a parâmei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "219. Ce reprezintă voltele?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) legăturile prin care parâmele se fixează la dispozitivele de legare existente la bord",
                "b) totalitatea manevrelor mobile de la bord",
                "c) ochiurile făcute de o parâma semirigida"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "220. In cazul unei rame, pana reprezintă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) îngroșarea brațului imediat după manșon",
                "b) partea ramei din care este manevrata",
                "c) partea lata în forma de lopata"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "221. In general o ancora se compune din următoarele parți :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) brațe , fus , diamant , inel , traversa",
                "b) traverse, brațe , diamant și eche",
                "c) inel , traversa, brațe și pană"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "222. Ce înțelegeți prin graparea ancorei :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ancora și lanțul sunt suprasolicitate",
                "b) ancora se târăște pe fundul apei",
                "c) ancora s-a agățat într-un corp dur pe fundul apei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "223. Dacă o parâma intra în compunerea altei parâme, mai groase , aceasta va purta denumirea de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lanƫanã",
                "b) garlin",
                "c) cordon"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "224. Adâncimea apei se măsoară cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lochul",
                "b) sonda",
                "c) barometrul"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "225. Fiecare rând de scânduri sau de table al învelișului ( bordajului ) exterior se numește :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) traversa",
                "b) copastie",
                "c) fila"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "226. Un observator care sta pe puntea navei cu fata spre prova , are în dreapta",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) bordul babord",
                "b) bordul tribord",
                "c) cuplul maestru"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "227. Cârma se compune din :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pană și eche",
                "b) dame și eche",
                "c) panã și dama"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "228. Ancora cu patru brațe este folosită :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la fluviu și ape interioare",
                "b) în golfuri și estuare",
                "c) la mare în ape de adâncime medie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "229. O baba simpla , formata dintr-o singura coloană prevăzuta cu traversa se numește :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tranchet",
                "b) turnichet",
                "c) binta"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "230. Piesele metalice de ghidare a parâmelor eliminând frecarea se numesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) binte",
                "b) babale",
                "c) turnicheti"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "231. Ce reprezintă patronarea unei parâme ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) protejarea contra frecării , prin învelirea unei porțiuni",
                "b) înfășurarea capetelor ca sa nu se destrame",
                "c) eliminarea unei porțiuni uzate"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "232. Piesa fundamentala de rezistenta a oricărei nave, situata în plan diametral , de la prova la pupa, se numește",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) chila",
                "b) etrava",
                "c) etambou"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "233. Care este elementul de baza la structura oricărui tip de parâma",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lanƫana",
                "b) firul",
                "c) garlinul"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "234. Piesele metalice mai mici , care servesc la luarea voltelor cu parâme mai subțiri se numesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tacheți",
                "b) trancheti",
                "c) turnicheti"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "235. Dispozitivele de construcție speciala , fixate în bordaj , cu rol de ghidare a parâmei se numesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) rodanțe",
                "b) urechi",
                "c) tacheți"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "236. Orificiul rotund prin care trece axul cârmei se numește",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) stelatura pupa",
                "b) etrava",
                "c) etambreul axului cârmei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "237. Viteza unei ambarcațiuni se măsoară cu",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Sonda",
                "b) Barometrul",
                "c) Lochul"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "238. Dama reprezintă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o scobitura în marginea superioara a bordajului , în care se introduce rama",
                "b) partea cea mai lată a ambarcațiunii",
                "c) locul în care se întâlnesc filele de bordaj cu copastia"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "239. In cazul unei ancore , diamantul este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) locul de unde se leagă capătul lanțului",
                "b) ramificația brațelor",
                "c) locul de împreunare a brațelor cu fusul"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "240. Cum se măsoară calibrul lanțului de ancora",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) grosimea la mijlocul zalei",
                "b) lățimea maxima a zalei la interior",
                "c) lungimea maxima a zalei la exterior"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "241. Dispozitivele de construcție speciala , fixate în punte , cu rol de ghidare a parâmei se numesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) rodanțe",
                "b) urechi",
                "c) tacheți"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "242. Cablurile fixate de cârma , cu ajutorul cărora se guvernează se numesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) eche",
                "b) troƫe",
                "c) pene"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "243. Vârtejul este :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) piesa de legătură inte cheia de împreunare a ancorei și cea a lanțului de ancora",
                "b) o za de lat de ancora",
                "c) o cheie de împreunare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "244. Orificiul rotund prin care trece axul elicei de propulsie se numește",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) etambou",
                "b) selatura pupa",
                "c) etambreul axului elicei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "245. Un observator care sta pe puntea navei cu fata spre prova , are în stânga",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) bordul babord",
                "b) bordul tribord",
                "c) cuplul maestru"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "246. Elementele de osatura transversale, fixate pe chila la intervale egale , se numesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) filă lacrimară",
                "b) coaste",
                "c) traverse"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "247. Locul de îmbinare a filelor se numește",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cusătura",
                "b) gurna",
                "c) binta"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "248. Din punct de vedere al materialului folosit la confecționarea paramelor, una din categoriile incluse în aceasta clasificare o reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) parâmele vegetale",
                "b) parâmele răsucite (garline)",
                "c) parâmele simple (lanțane)"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "249. La parâmele vegetale și sintetice circumferința reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) greutatea",
                "b) grosimea",
                "c) rezistenta"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "250. Chila reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) element de rezistenta al navei dispus în planul transversal al navei",
                "b) element de rezistenta dispus în planul longitudinal al navei",
                "c) element de rezistență dispus în planul cuplului maestru"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "251. Sarcina la care parâma se rupe reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) grosimea parâmei",
                "b) greutatea parâmei",
                "c) rezistența parâmei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "252. Ce este merlinul?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o lanƫanã de 40-80mm grosime folosită la legarea navelor mici",
                "b) o parâmă cu grosimea de 100- 620mm folosită la legarea sau remorcarea navei",
                "c) o parâmă subțire confecționată din trei sfilate, folosită la înfășurare, legături și patronări"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "253. Raiul unei macarale este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o rola care se învârtește liber în jurul unui ax",
                "b) o piesa formata din doua placi laterale ovale și doua tocuri",
                "c) piesa de susținere a macaralei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "254. Etrava reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prelungirea chilei în tribord și babord",
                "b) prelungirea chilei în prova",
                "c) prelungirea chilei în pupa"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "255. Care din următoarele parâme au în interior o inima vegetala, pentru protecția acestora?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) parâmele sintetice",
                "b) parâmele vegetale",
                "c) parâmele metalice"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "256. Capacitatea parâmei de a se îndoi, fără a-si modifica structura interioara, reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) flexibilitatea parâmei",
                "b) greutatea parâmei",
                "c) rezistența parâmei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "257. Ce este grandeea?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o lanƫanã cu circumferința de 25-120mm cusuta pe marginea unei vele sau tenzi pentru a o întări.",
                "b) o parâmă cu grosimea de 100- 620mm folosită la legarea sau remorcarea navei",
                "c) o lanțană subțire de 7-8mm folosită la înfășurări și patronări de parâme groase"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "258. Sbirul este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o rola care se învârtește liber în jurul unui ax",
                "b) o piesa formata din doua placi laterale ovale și doua tocuri",
                "c) inel de parâmă confecționat prin matisire care servește la prinderea unui palanc pe o parâmă sau pe un scondru"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "259. Etamboul reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prelungirea chilei în tribord și babord",
                "b) prelungirea chilei în prova",
                "c) prelungirea chilei în pupa"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "260. Caracteristicile parâmelor sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) flotabilitatea, greutatea, rezistenta, elasticitatea",
                "b) grosimea, greutatea, rezistenta, flexibilitatea, elasticitatea",
                "c) grosimea, flotabilitatea, greutatea, elasticitatea, asieta"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "261. Ce se înțelege prin \"bătaia parâmei\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) separarea firelor după lungime și eliberarea produsului secundar numit stupa",
                "b) îndepărtarea materialelor străine din materia prima",
                "c) operațiunea prin care firele sunt răsucite"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "262. Ce este saula?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o lanƫanã de 40-80mm grosime folosită la legarea navelor mici",
                "b) o parâmă cu grosimea de 100- 620mm folosită la legarea sau remorcarea navei",
                "c) o parâmă cu grosimea de 15-40mm folosită la bandulă sau la pavilion"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "263. Macaralele în marinărie sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dispozitive de genul scripeților, folosite pentru ridicarea unor greutăți sau pentru schimbarea direcției de tracțiune a unei parâme",
                "b) instalații de forță prevăzute cu cabina și panou de comandă",
                "c) instalații compuse dintr-un ansamblu de grinzi metalice sudate sau nituite, aflate pe nave"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "264. Coastele reprezintă elemente de construcție ale navei dispuse în planul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) liniei de plutire",
                "b) longitudinal",
                "c) transversal"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "265. Pescajul navei reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) distanta măsurată pe orizontală în planul cuplului maestru, la nivelul liniei de plutire de plina încărcare",
                "b) distanta măsurată pe orizontala în planul cuplului maestru, intre extremitățile celor doua borduri",
                "c) distanța măsurată pe verticală, de la linia de bază până la linia de plutire"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "267. Ce se înțelege prin \"pieptănarea parâmei\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) separarea firelor după lungime și eliberarea produsului secundar, numit stupa",
                "b) îndepărtarea materialelor străine din materia primă",
                "c) operațiunea prin care firele sunt rasucite"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "268. Ce este lusinul?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o lanƫanã de 40-80mm grosime folosită la legarea navelor mici",
                "b) o lanțană mai fină decât merlinul, folosită la patronări și înfășurări fine",
                "c) o parâmă cu grosimea de 15-40mm folosită la bandulă sau la pavilion"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "269. Părțile componente ale unei macarale sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) căpățâna, raiul, sbirul",
                "b) căpățâna, raiul, troliul",
                "c) căpățâna, raiul, spiraiul"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "270. Varangele reprezintă elemente de construcție ale navei dispuse în planul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) liniei de plutire",
                "b) longitudinal",
                "c) transversal"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "271. Ce este flotabilitatea?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) proprietatea navei de a reveni la poziția inițială, după ce a fost scoasă din starea de echilibru",
                "b) proprietatea navei de a pluti, la pescajul mediu determinat, cu încărcătura sa",
                "c) proprietatea navei de a-si schimba direcția mișcării"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "272. Păstrarea parâmelor vegetale se face ferindu-le de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) întuneric și lipsa de ventilație",
                "b) umezeala și radiația solara",
                "c) nu necesita masuri speciale pentru păstrare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "273. Ce se înțelege prin \"toarcerea parâmei\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) separarea firelor după lungime și eliberarea produsului secundar, numit stupa",
                "b) îndepărtarea materialelor străine din materia prima",
                "c) operațiunea prin care firele sunt răsucite spre dreapta"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "274. Ce este garlinul?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o lanƫanã de 40-80mm grosime folosită la legarea navelor mici",
                "b) o parâmă cu grosimea de 100- 620mm folosită la legarea sau remorcarea navei",
                "c) o lanțană subțire de 7-8mm folosită la înfășurări și patronări de parâme groase"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "275. Palancurile sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dispozitive compuse din una sau mai multe macarale cu cate unul sau mai multe raiuri, prin care se trece o parâmă denumită curent",
                "b) instalații compuse din grinzi de otel sudate sau îmbinate prin nituire",
                "c) ansamble alcătuite din mai multe bigi sau cranice, folosite la ridicarea de greutăți și deschiderea capacelor de magazii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "276. Elementul de baza din structura oricărei parâme este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) șuvița",
                "b) firul",
                "c) lanțana"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "277. Din ce sunt confecționate parâmele metalice?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) din fire de cânepă, in, bumbac, iuta",
                "b) din fire de sarma de otel zincat cu grosimi de 0,2-0,6mm",
                "c) din fire de capron, relon, nailon, polipropilena"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "278. Mandarul simplu este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dispozitiv de ridicat, alcătuit din doua macarale duble",
                "b) dispozitiv de ridicat alcătuit dintr-o macara fixa, prin care trece o parâmă",
                "c) dispozitiv de ridicat alcătuit dintr-o macara mobila, prin care trece un curent"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "279. Parâmele simple se numesc si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) garline",
                "b) lanțane",
                "c) cordoane"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "280. Din ce sunt confecționate parâmele vegetale?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) din fire de cânepă, in, bumbac, iuta",
                "b) din fire de sarma de otel zincat cu grosimi de 0,2-0,6mm",
                "c) din fire de capron,relon,nailon, polipropilena"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "281. Furcheții sunt :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) piese metalice în forma de furca pe care se sprijină ramele ambarcațiunii",
                "b) montant de copastie",
                "c) nu sunt necesari pentru ambarcațiuni"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "282. Din ce sunt confecționate parâmele sintetice?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) din fire de cânepă, in, bumbac, iuta",
                "b) din fire de sarma de otel zincat cu grosimi de 0,2-0,6mm",
                "c) din fire de capron, relon, nailon, polipropilena"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "283. Mai multe fire răsucite intre ele formează:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o șuviță",
                "b) o lanțană",
                "c) o sfilata"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "284. Vesta de salvare este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) in inventarul ambarcațiunii",
                "b) mijloc individual de salvare care face parte din inventarul ambarcațiunii",
                "c) protejată termic"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "285. Ce sunt parâmele de sizal?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) parâme vegetale confecționate din fire lungi de cânepă",
                "b) parâme vegetale confecționate din fibre de bananier",
                "c) parâme vegetale confecționate din frunze de cactus"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "286. Unde se păstrează parâmele pentru uzul curent?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) in magazii",
                "b) pe punte",
                "c) intr-un cofferdam"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "287. Vesta de salvare asigura:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ieșirea la suprafață a persoanei căzute în apă, chiar în stare de inconștiență, și menține gura acesteia deasupra nivelului apei",
                "b) la confecționarea baloanelor și paietelor",
                "c) la confecționarea saulelor la ambarcațiuni sport și de agrement"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "288. Ce trebuie verificat la primirea parâmelor vegetale la bord?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) culoarea și mirosul",
                "b) calitatea zincării",
                "c) sa nu fie îndoite"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "289. La ce sunt folosite parâmele de cânepa?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la confecționarea manevrelor curente, la bărci și la arborada",
                "b) la confecționarea baloanelor și paietelor",
                "c) la confecționarea saulelor, la ambarcațiuni sportive și de agrement"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "290. Barbetele sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) parâme folosite pentru prinderea butoaielor și ridicarea acestora",
                "b) capete de parâmă folosite la botare",
                "c) capete de parâmă fixate la prova și la pupa bărcii."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "291. Boturile sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) capete de parâmă vegetala sau de lanț fixate cu unul din capete solid în punte pentru fixarea provizorie a unei parâme.",
                "b) siguranțe ale axului unei macarale.",
                "c) știfturi de siguranță ale unei chei de împreunare."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "292. Care dintre afirmație de mai jos este adevărata?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tacheții sunt piese metalice formate din doua coloane cilindrice care servesc la luarea voltelor la parâmele date ca legături la mal",
                "b) tacheții sunt piese metalice în forma de T, montate pe punte, pe copastie și servesc pentru luarea voltelor la parâme mai subțiri",
                "c) tacheții sunt piese metalice de ghidarea parâmelor, cu minimum de frecare."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "293. Care dintre afirmațiile de mai jos este adevărata?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) turnichetii sunt piese metalice în forma de T, ce se folosesc la luarea voltelor la diverse parâme",
                "b) turnichetii sunt piese metalice de ghidarea parâmelor, cu minimum de frecare",
                "c) turnichetii sunt piese metalice pentru agățat lanțuri, parâme vegetale și sârme."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "294. Care dintre afirmațiile de mai jos este falsa?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) viteza navei se măsoară în noduri.",
                "b) viteza navei se măsoară în Mile marine pe ora (Mm/h)",
                "c) viteza navei se măsoară cu anemometrul."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "295. Ce tip de ancora este ancora Amiralitate?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu fus articulat.",
                "b) cu gheare de pisica.",
                "c) cu fus nearticulat"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "296. Ce tip de ancora este ancora Hall?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu fus articulat.",
                "b) cu gheare de pisica.",
                "c) cu fus nearticulat"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "297. Cum se măsoară greutatea unei parâme?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin măsurarea circumferinței ei",
                "b) prin măsurarea sarcinii la care se rupe parâma",
                "c) prin măsurarea greutății în kilograme a unui metru liniar din parâma respectiva"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "298. Cum se măsoară grosimea unei parâme?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin măsurarea circumferinței ei",
                "b) prin măsurarea sarcinii la care se rupe parâma",
                "c) prin măsurarea greutății în kilograme a unui metru liniar din parâma respectiva"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "299. Cum se măsoară rezistenta unei parâme?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin măsurarea circumferinței ei",
                "b) prin măsurarea sarcinii la care se rupe parâma",
                "c) prin măsurarea greutății în kilograme a unui metru liniar din parâma respectiva"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "300. Echea reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) partea cârmei scufundata în apa, care realizează efectul de guvernare",
                "b) o piesa sub forma unei bare sau a unui sector ce se fixează în capul penei cârmei.",
                "c) partea de cârmă ce se afla deasupra liniei de plutire."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "301. Elementele componente ale unei ancore sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nara de ancora, vinciul de ancora și lanțul de ancorare.",
                "b) fus, diamant, brațe și gheare.",
                "c) stopa de lanț, lanțul de ancorare și tubul de ghidare."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "302. Elementele structurale ale unei parâme sintetice sau vegetale sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) firul, sfilata, șuvița, lanțana, cordonul, garlinul.",
                "b) firul, șuvița, lanțana, cordonul, garlinul, gașa.",
                "c) firul, sfilata, șuvița, lanțana, cordonul, carlinga."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "303. In categoria nodurilor speciale intra:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nodul gura de știucă, nodul de remorca",
                "b) nodul de bandula, nodul picior de câine",
                "c) nodul de scaun, nodul de ancora."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "304. In categoria obiectelor de armament destinate pentru navigație din inventarul bărcii, intra:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ghiordel",
                "b) cuțit de gabier",
                "c) compas de barca"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "305. In categoria obiectelor de armament destinate pentru navigație și semnalizare din inventarul bărcii, intra:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pistol de semnalizare",
                "b) butoiaș cu apă potabilă",
                "c) ispol"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "306. In categoria obiectelor de armament destinate pentru navigație și semnalizare din inventarul bărcii, intra:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) colacii de salvare",
                "b) pavilioane de semnalizare cu brațele.",
                "c) veste de salvare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "307. In categoria obiectelor de armament destinate pentru navigație și semnalizare din inventarul bărcii, intra:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) bastonul de pavilion cu pavilionul",
                "b) ciocanul",
                "c) ghiordelul"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "308. In categoria obiectelor de armament destinate pentru salvare echipaj, în inventarul bărcii intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pistolul de semnalizare",
                "b) butoias cu apă potabilă",
                "c) ispolul"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "309. In categoria obiectelor de armament destinate pentru salvare, în inventarul bărcii intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) trusa cu scule de marangozerie",
                "b) veste de salvare",
                "c) compasul de barca"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "310. In categoria obiectelor de armament destinate pentru salvare, în inventarul bărcii intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) colaci de salvare",
                "b) ghiordelul",
                "c) compasul de barca"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "311. In categoria obiectelor de armament destinate pentru salvarea personalului, în inventarul bărcii intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) trusa cu medicamente",
                "b) trusa cu scule de marangozerie",
                "c) felinar de vânt"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "312. In categoria obiectelor de armament destinate pentru vitalitatea bărcii, intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) butoiaș cu apa potabila",
                "b) ghiordelul",
                "c) veste de salvare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "313. In categoria obiectelor de armament destinate pentru vitalitatea bărcii, intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pavilioane de semnalizare cu brațele.",
                "b) ispolul",
                "c) ciocanul"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "314. In categoria obiectelor de armament destinate pentru vitalitatea bărcii, intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dopuri de lemn",
                "b) bastonul de pavilion cu pavilionul",
                "c) centuri de salvare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "315. In categoria obiectelor de armament destinate pentru vitalitatea bărcii, intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) trusa cu medicamente",
                "b) pene, cuie, câlți",
                "c) compasul de barca"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "316. In categoria obiectelor de armament destinate pentru vitalitatea bărcii, intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) trusa cu medicamente",
                "b) trusa cu scule de marangozerie",
                "c) felinar de vânt"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "317. In categoria propulsoarelor intra:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) zbaturile, ramele, elicele.",
                "b) linia de arbori, bulbul, cârma.",
                "c) cârma, timona, mașina cârmei."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "318. Instalația de ancorare a navei reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un complex de mecanisme care, acționate separat sau în comun, produce momentul girației (schimbarea direcției de înaintare a navei)",
                "b) instalația cu care se realizează propulsia navei",
                "c) instalația cu care se realizează fixarea într-o poziție bine determinată a navei."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "319. Instalația de ancorare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) reprezintă un ansamblu de piese și mecanisme destinate pentru a realiza deplasarea navei.",
                "b) reprezintă un ansamblu de piese și mecanisme destinate pentru menținerea navei într-o zona în afara caii navigabile, sau într-o poziție stabila, de către comandantul navei.",
                "c) reprezintă un ansamblu de piese și mecanisme cu ajutorul cărora se guverneaza nava în locul voit"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "320. Instalația de guvernare a navei reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un complex de mecanisme care, acționate separat sau în comun, produce momentul girației (schimbarea direcției de înaintare a navei)",
                "b) instalația cu care se realizează propulsia navei",
                "c) instalatia cu care se realizează fixarea într-o pozitie bine determinată a navei."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "321. Instalația de guvernare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) reprezintă un ansamblu de piese și mecanisme destinate pentru menținerea navei într-o zona în afara caii navigabile, sau într-o poziție stabila, de către comandantul navei.",
                "b) reprezintă un ansamblu de piese și mecanisme care trebuie sa asigure respectarea drumului impus navei sau schimbarea direcției de înaintare a navei.",
                "c) reprezintă un ansamblu de piese și mecanisme destinate pentru a realiza deplasarea navei."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "322. Instalația de propulsie a navei:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) reprezintă un ansamblu de piese și mecanisme destinate pentru a realiza deplasarea navei.",
                "b) reprezintă un ansamblu de piese și mecanisme destinate pentru menținerea navei într-o zona în afara caii navigabile, sau într-o poziție stabila, de către comandantul navei.",
                "c) reprezintă un ansamblu de piese și mecanisme cu ajutorul cărora se asigură nava în locul voit și într-o pozitie aleasă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "323. La ce folosește un palanc dublu?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pentru multiplicarea forței de acționare a manevrelor curente de la bord și ridicarea de diferite greutăți.",
                "b) pentru dublarea forței de tracțiune a unei fungi",
                "c) pentru ridicarea greutăților și la instalațiile de gruie."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "324. Mațagonirea reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) operațiunea de furbisare a alămurilor de pe nava",
                "b) operațiunea de îndepărtare a ruginii și a stratului de vopsea sub care se afla rugina.",
                "c) operațiunea de aplicare a grundului pe suprafețe curățate de rugină."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "325. Nodul de ancora este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de împreunare",
                "b) de legătură",
                "c) de cârlig"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "326. Nodul de capelatura este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de legătură",
                "b) de cârlig",
                "c) special"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "327. Nodul de scota este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de legătură",
                "b) de cârlig",
                "c) special"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "328. Nodul de pescar este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de împreunare",
                "b) de legătură",
                "c) de cârlig"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "329. Nodul de scaun simplu este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de împreunare",
                "b) de legătura",
                "c) de cârlig"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "330. Nodul de schelă este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de legătură",
                "b) de cârlig",
                "c) special"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "331. Nodul de văcar este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de împreunare",
                "b) de legătură",
                "c) de cârlig"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "332. Nodul gura de știucă este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de împreunare",
                "b) de legătura",
                "c) de cârlig"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "333. Nodul lat este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de împreunare",
                "b) de legătură",
                "c) de cârlig"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "335. Nodurile de cârlig sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nodurile folosite la legarea unui capăt de parâmă de cârligul unei macarale",
                "b) nodurile folosite la împreunarea a doua capete de parâmă de grosimi aproximativ egale.",
                "c) nodurile folosite la fixarea unui capăt de parâmă."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "336. Nodurile de împreunare sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nodurile folosite la legarea navelor",
                "b) nodurile folosite la împreunarea a doua capete de parâmă de grosimi aproximativ egale",
                "c) nodurile folosite la fixarea unui capăt de parâmă."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "337. Nodurile de legătura sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nodurile folosite la legarea unui capăt de parâmă de cârligul unei macarale",
                "b) nodurile folosite la împreunarea a doua capete de parâmă de grosimi aproximativ egale.",
                "c) nodurile folosite la fixarea unui capăt de parâmă."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "338. Obiectele din alama și bronz se piturează?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) uneori"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "339. Parâmele de bumbac sun folosite la confecționarea baloanelor și paietelor?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) uneori"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "341. Parâmele sintetice sunt folosite la confecționarea saulelor la ambarcațiuni sport și de agrement ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) uneori"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "342. Parâmele de cânepă sunt confecționate din fire de cânepă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) uneori"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "343. Parâmele vegetale și sintetice sunt folosite la confecționarea baloanelor și paietelor?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) uneori"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "344. Parâmele de vegetale și sintetice sunt folosite la confecționarea manevrelor curente?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) uneori"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "345. Parâmele de cânepă sunt folosite la confecționarea saulelor la ambarcațiuni sport și de agrement?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) uneori"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "346. Parâmele vegetale și sintetice uzate sunt folosite la confecționarea baloanelor și paietelor?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) uneori"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "350. Parâmele de sizal sunt confecționate din fire de cânepă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) uneori"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "351. Vinciul este :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) instalație fixa",
                "b) mecanism de ridicat sau tras, manual sau acționat mecanic, cu ax orizontal utilizat la bord pentru virarea ancorei, manevrelor unei bigi, a curenților palancurilor gruelor de barcă",
                "c) instalație mecanica de forță"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "354. Nodul de scaun simplu (de gașă) se utilizează la:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) împreunarea a doua parâme",
                "b) legarea ambarcațiunii de instalațiile",
                "c) nu are utilitate"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "355. Cabestanul este :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) instalație mecanica",
                "b) ddeis ppoez cithive ud,e b mabaanleev, rbainte,tacheti,la",
                "c) Mecanism de punte, pentru virarea ancorei sau manevrarea parâmelor, acționat manual sau electro-mecanic, cu ax vertical"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "356. Gruiul este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) instalație mecanica",
                "b) suport ambarcatiune",
                "c) dispozitiv de ridicare a greutatilor și a bãrcilor având o formã curbatã,o razã relativ micã de actiune comparativ cu bigile și granicele și o capacitate de ridicare scãzutã"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "358. Principiul lui Arhimede se aplica:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) oricărui corp care zboară",
                "b) oricărui corp aflat la sol.",
                "c) oricarui corp scufundat în apă."
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "359. Rodanțele sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) apărătoare ale macaralelor",
                "b) apărătoare ale gașelor",
                "c) dispozitive de vitalitate"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "360. Sabordurile sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) deschideri în bordaj de forma dreptunghiulara, cu destinații diferite.",
                "b) deschideri în punte de dimensiuni mici, destinate accesului oamenilor în compartimentele aflate sub punte.",
                "c) deschideri în punte destinate pentru iluminarea și aerisirea compartimentului masini și căldări."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "361. Sarcina la care parâma se rupe reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) grosimea parâmei",
                "b) greutatea parâmei",
                "c) rezistența pâramei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "362. Saula \"tin-te bine\" se întâlnește la :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) bărcile de serviciu",
                "b) bărcile de salvare",
                "c) bărcile de serviciu, bărcile de agrement"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "363. Se poate da a doua mana de vopsea, dacă nu s-a uscat primul strat de vopsea?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da",
                "b) nu",
                "c) nu contează"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "364. Sunt elemente componente ale instalației de ancorare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) stopa de lanț, vinciul de ancoră și nara de punte.",
                "b) babale, parâme, turnicheti",
                "c) vinciuri de balansină, balansina și cârligul de sarcină"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "365. Sunt elemente componente ale instalației de ancorare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) fungile, brațele și școtele.",
                "b) ancora, nara de ancora și ghidajele de lanț.",
                "c) straiurile, sarturile și pataraținele"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "366. Tambuchiurile sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) deschideri în punte necesare încărcării- descărcării mărfii în/din magazii.",
                "b) deschideri în punte de dimensiuni mici, destinate accesului oamenilor în compartimentele aflate sub punte.",
                "c) deschideri în punte, destinate pentru iluminarea și aerisirea compartimentului mașini și căldări."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "367. Timona reprezintă un element component al instalației de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) propulsie",
                "b) guvernare",
                "c) ancorare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "368. Umezeala alterează parâmele vegetale?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da",
                "b) nu",
                "c) uneori"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "369. Unde se afla puntirile bărcii?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) in prova și în pupa",
                "b) in mijlocul bărcii",
                "c) pe fundul bărcii."
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "370. Voltele în cadrul lucrărilor de matelotaj sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) noduri marinărești",
                "b) legături prin care se fixează parâmele la dispozitive speciale de legare",
                "c) întoarceri ale navelor sub actiunea vântului."
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "371. Voltele se pot face la :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) baba, tacheti, cavile",
                "b) baba, turnicheți, somare",
                "c) baba, galion, goling"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Marinarie",
            "difficulty": 1
        },
        {
            "question": "408. La deplasarea înainte a bărcii, efectul cârmei determină",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) orientarea provei în vânt",
                "b) orientarea provei în bordul în care s- a pus cârma şi a pupei în bordul opus",
                "c) mersul în linie dreaptă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "409. La marş înainte, pupa este abătută",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) spre dreapta",
                "b) în bordul pasului elicei, iar prova are tendinţa să gireze în bordul opus pasului elicei",
                "c) spre stânga"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "410. Acostarea ambarcaţiunii la mal neamenajat",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu este recomandată",
                "b) se face cu vigilenţă sporită, protejând elicea şi cârma",
                "c) este interzisă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "411. Depăşirile se execută",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la o distanță cât mai mare de nava depăşită, viteza se adaptează situaţiei, urmărind a nu face valuri pentru nava depăşită, dar acordând atenţia necesară întâmpinării valurilor din siajul acesteia",
                "b) de către ambarcaţiunea care merge pe mijlocul şenalului",
                "c) oricum deoarece nu sunt reguli speciale de siguranţă în cazul acestei manevre"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "412. Remorcarea este o operaţiune la care lungimea parâmei de remorcă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se va alege astfel încât nava remorcată să nu suporte curentul respins de elicea navei remorcher",
                "b) nu contează lungimea parâmei de legare",
                "c) nu se fac remorcări cu ambarcaţiuni"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "413. Înainte de pătrunderea în ecluză",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu trebuiesc făcute pregătiri speciale la bordul ambarcaţiunilor",
                "b) la bordul ambarcaţiunilor parâmele trebuie ţinute din scurt şi componentele echipamentului trebuie să nu depăşească limitele navei",
                "c) conducătorul nu are nici o obligaţie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "414. Din motive de siguranţă şi fluidizare a circulaţiei, pentru accelerarea traversării şi pentru exploatarea în plin a ecluzelor",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) personalul de supraveghere a ecluzelor poate emite ordine care să completeze regulile iniţial prevăzute sau care se abat de la acestea, iar conducătorii navelor trebuie să urmeze aceste ordine în zona de ecluzare",
                "b) personalul de supraveghere a ecluzelor nu are permisiunea de a emite ordine care să completeze regulile iniţial prevăzute",
                "c) este permisă orice măsură propusă de conducătorii navelor"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "415. În funcţie de tipul cocii, viteza bărcii este cu atât mai mare cu cât",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) suprafaţa udată la viteza maximă este mai mare",
                "b) suprafaţa udată la viteza maximă este mai mică",
                "c) elicea are mai multe pale"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "416. Înainte de a părăsi locul de acostare",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) îndepărtaţi orice material în plus din barca şi lăsaţi-l la ţărm; dacă aveţi nevoie de el la bord, asiguraţi-vă că este depozitat în siguranţă",
                "b) nu este nevoie de asemenea pregătire",
                "c) puteţi depozita materialele după libera dvs. alegere"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "417. Alegerea celei mai bune elice şi a înălţimii motorului necesită verificarea câtorva lucruri precum",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) turaţia maximă a motorului; viteza bărcii; ventilaţia elicei; abilitatea de glisare a bărcii; presiunea de răcire",
                "b) lungimea bărcii",
                "c) pescajul şi lăţimea bărcii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "418. Numărul de ture pe care îl efectuează o elice în mişcarea sa de rotaţie într-un interval de timp de un minut reprezintă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) numărul de rotaţii al elicei pe minut (RPM)",
                "b) spaţiul parcurs de elice într-un minut",
                "c) viteza de rotaţie a elicei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "419. Legăturile ambarcaţiunii sunt",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) parâma pupa",
                "b) parâma prova şi pupa",
                "c) parâma prova"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "420. Locul de ancorare trebuie să îndeplinească o serie de condiţii",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să permită o ancorare-plecare uşoară, fără să deranjeze alte ambarcaţiuni",
                "b) nu sunt impuse condiţii speciale pentru ancorare",
                "c) este interzisă ancorarea în afara radelor"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "421. În cazul în care nu putem observa în mod clar felul cum acţionează curentul şi vântul în cazul manevrei de ,,Om la apă”",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu facem manevra de recuperare a celui căzut în apă",
                "b) venim iniţial cu prova pe direcţia inversă a rezultantei, căutând efectul minim de derivă şi ne apropiem de cel căzut în apă cu viteza scăzută",
                "c) nu este nevoie de nici o estimare a efectului curentului și vântului"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "422. În timpul ecluzării, în camerele ecluzelor",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este interzisă curăţarea şi maturarea navelor şi corpurilor flotante",
                "b) este permisă curăţarea şi maturarea navelor şi corpurilor flotante",
                "c) nu este prevăzută expres această regulă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "423. Conducerea de motovehicule nautice (skyjet) este supusă următoarelor limite",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) motorul nu se opreşte la căderea conducătorului",
                "b) regulile de construcţie privesc pe constructor",
                "c) motorul trebuie sau să se oprească automat la căderea conducătorului, sau să fie cuplat automat pe cea mai mică viteză, în timp ce vehiculul trebuie să se oprească sau să descrie o traiectorie circulară"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "424. Dacă barca dumneavoastră este echipată cu un sistem de cablu împinge-trage, mecanic",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) toate componentele sistemului trebuie să îndeplinească sau să depăşească cererile menţionate în standard",
                "b) componentele sistemului pot fi alese după aprecierea proprietarului",
                "c) nu există reguli şi standarde pentru această instalaţie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "425. Manevra de oprire se execută astfel",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) in cazul în care nu exista nici un motiv sa faceţi altfel, reduceţi în mod gradat viteza, deoarece reducerea brusca poate face ca valul de pupa sa se lovească de oglinda bărcii și sa se reverse în interior",
                "b) ambarcaţiunea se opreşte rapid, prin punerea pe zero și cuplarea pe înapoi a motorului",
                "c) barca se opreşte din mers prin scoaterea cheii din contact"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "426. Dacă înclinaţi motorul în sus la viteze mari",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu se observa nici un efect",
                "b) forţele turbionare vor acţiona brusc şi pot cauza pierderea controlului ambarcaţiunii",
                "c) barca se înclină în bordul pasului elicei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "427. La acostare se folosesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) baloane de protecţie polivinilice umplute cu aer",
                "b) corpul ambarcaţiunii nu se protejează",
                "c) orice fel de obiecte din metal sau lemn"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "428. Cu cât viteza de deplasare este mai mare",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) presiunea apei asupra penei cârmei va fi mai mare, iar schimbarea direcţiei mai rapidă",
                "b) presiunea apei asupra penei cârmei va fi mai mică, iar schimbarea direcţiei mai înceată",
                "c) viteza nu influenţează rapiditatea schimbării direcţiei de navigaţie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "429. Mărimea şi forma elicei depinde de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) turaţia dată la axul elicei",
                "b) puterea motorului, mărimea corpului ambarcaţiunii şi scopul pentru care este destinată barca, tracţiune sau viteză",
                "c) parametrii motorului"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "430. Guvernarea poate fi îmbunătăţită de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) reducerea numărului de cârme",
                "b) mărimea suprafeţei penei cârmei",
                "c) micşorarea unghiului de rotire a cârmei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "431. La manevra de acostare, pe lângă calităţile manevriere ale navei, tot timpul se va ţine cont de vânt şi curent urmărindu-se",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să se evite influenţa lor",
                "b) ca forţa acestora să fie folosită în ajutorul manevrei şi nu manevra săse împotrivească acestora",
                "c) nu se ţine cont de vânt şi curent"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "432. Manevra de ”Om la apă“ este o manevră clasică de recuperare care se efectuează",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ţinând cont de efectul vântului şi curentului asupra ambarcaţiunii şi persoanei căzute în apă, astfel încât ambarcaţiunea să nu derive peste omul din apă",
                "b) nu este nevoie de nici o estimare a efectului curentului și vântului",
                "c) această manevră o fac numai navele de salvare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "433. În camerele ecluzei:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu se folosesc baloanele/trancheţi pentru acostare",
                "b) este obligatorie folosirea trancheţilor pentru acostare",
                "c) se folosesc trancheţi care trebuie să fie flotabili, dacă nu sunt legaţi strâns- fixaţi de navă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "434. Conducerea de motovehicule nautice (skyjet-uri) este supusă următoarelor limite",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se poate naviga atât ziua cât şi noaptea",
                "b) este permisă numai ziua",
                "c) nu sunt prevăzute reguli exprese"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "435. Indicatorul înclinării este folosit",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la ridicarea cizmei/motorului pentru controlul elicei",
                "b) numai de persoanele autorizate",
                "c) sa orienteze motorul la un unghi predeterminat pentru o performanţă mai bună în navigaţie"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "436. Înainte de a părăsi locul de acostare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) asiguraţi-vă că operaţiunile de pe algoritmul verificărilor dumneavoastră au fost parcurse",
                "b) nu se fac nici un fel de verificări",
                "c) toate verificările sunt făcute de către un service"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "437. Pasul elicei reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mărimea diametrului butucului",
                "b) lungimea palei",
                "c) spaţiul parcurs de marginea exterioară a elicei în mişcarea de translaţie efectuată de-a lungul axei de rotaţie în timpul unei rotaţii complete"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "438. Locul de ancorare trebuie să îndeplinească o serie de condiţii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este interzisă ancorarea în afara radelor",
                "b) să fie un loc ferit de efectele curenţilor, valurilor şi vântului",
                "c) nu sunt impuse condiţii speciale pentru ancorare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "439. În categoria ecluzelor intră:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ecluzele şi suprafeţele de apă dinăuntrul şi dinafara sasurilor ecluzelor care servesc legării la cheu, înşiruirii şi aşteptării navelor –avanporturile de ecluză",
                "b) barajele şi porţile amonte şi aval",
                "c) numai sasurile ecluzelor"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "440. În timpul ecluzării, în camerele ecluzelor",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ambarcaţiunile mici pot să staţioneze oriunde în interiorul camerei",
                "b) ambarcaţiunile mici nu au voie să ecluzeze",
                "c) ambarcaţiunile mici trebuie să păstreze suficientă distanţă faţă de alte nave"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "441. Conducerea de motociclete nautice (skyjet) este supusă următoarelor limite:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) conducătorul şi însoţitorul trebuie să poarte veste de salvare",
                "b) conducătorul şi însoţitorul nu trebuie să poarte veste de salvare",
                "c) conducătorul şi însoţitorul nu trebuie să poarte veste de salvare, dacă sunt buni înotători"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "442. Mişcarea transversală a unei nave în jurul unei axe longitudinale reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tangaj",
                "b) ruliu",
                "c) mişcare ascensională"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "443. \"Mărimea’’ forţei ce acţionează asupra timonei este influenţată de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) puterea motorului, de câtă porţiune din elice este în apă, de tipul şi pasul elicei",
                "b) numai de puterea motorului",
                "c) numai de pasul elicei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "444. Instalaţia de guvernare se compune din",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) timonă şi transmisie",
                "b) timona sau manipulatorul electric; servomotorul la navele mari; sistemul de transmisie timonă- servomotor-cârmă; cârma propiu- zisă",
                "c) timona"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "445. Elicea are pas stânga dacă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la mersul înainte al ambarcaţiunii elicea se învârte la dreapta",
                "b) la mersul înapoi al ambarcaţiunii elicea se învârte la dreapta",
                "c) la mersul înainte al ambarcaţiunii elicea se învârte la stânga"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "446. În cazul acostării cu bordul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nava se apropie de cheu sub un unghi ascuţit, pentru a atenua impactul provei cu cheul",
                "b) ambarcaţiunea se apropie de cheu pe o direcţie perpendiculară pe acesta",
                "c) ambarcaţiunea se apropie de cheu din orice pozitie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "447. Reuşita ancorării depinde şi de folosirea corectă a lungimii parâmei/lanţului de ancorare şi anume",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu sunt stabilite reguli speciale privind lungimea lanţului/parâmei de ancorare",
                "b) lungimea parâmei/lanţului de ancorare nu influenţează siguranţa ancorării",
                "c) lungimea parâmei/lanţului la ancoră trebuie să fie de 3-5 ori adâncimea"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "448. În zona de ecluzare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ancorele trebuie să fie ridicate la post şi asigurate",
                "b) ancorele pot fi folosite în ecluză",
                "c) nu sunt prevăzute reguli speciale pentru acest caz"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "449. O ambarcaţiune este dificil de controlat în timpul navigaţiei dacă este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) echipată cu motoare de puteri mai mari decât cea pentru care a fost proiectată (,,overpower’’)",
                "b) este echipată cu motoare cu putere asemănătoare cu cea pentru care a fost proiectată",
                "c) nu este importantă puterea motorului"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "450. Dacă barca devine instabilă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) măriţi viteza pentru a stabiliza deplasarea",
                "b) reduceţi viteza în mod gradat, nu acceleraţi, opriţi testul de navigaţie în viteza pe apă, apoi verificaţi barca şi echipamentul, iar în cazul în care consideraţi că este nevoie, contactaţi- vă dealer-ul sau un expert pentru a vă ajuta",
                "c) nu este nevoie de nici o verificare, continuaţi mersul la aceeaşi parametri, deoarece fenomenul de instabilitate dispare după scurt timp"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "451. Pentru alegerea elicei care să corespundă exigenţelor dvs. trebuie să ţineţi cont de următoarele elemente",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tonajul bărcii",
                "b) experienţa conducătorului",
                "c) viteza probabilă a bărcii, care este cea mai bună elice pentru designul şi viteza bărcii dumneavoastră; modul în care doriţi să folosiţi barca; testarea pasului elicei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "452. Înmulţind rotaţiile pe minut (RPM) cu pasul elicei, se obţine:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) valoarea rezistenţei elicei",
                "b) spaţiul parcurs de ambarcaţiune într- un minut",
                "c) numărul de pale de elice"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "453. Locul de ancorare trebuie să îndeplinească o serie de condiţii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu sunt impuse condiţii speciale pentru ancorare",
                "b) este interzisă ancorarea în afara radelor",
                "c) să permită plecarea rapidă a navei de la ancoră, în orice condiţii, ziua sau noaptea"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "454. În zona de ecluzare este interzisă depăşirea, navele au voie să treacă pe lângă alte nave care aşteaptă în ecluză:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) atunci când conducătorul sau pasagerii consideră necesar",
                "b) numai atunci când ambarcaţiunile trebuie să fie ecluzate înainte sau pentru a se poziţiona în spaţiile libere aflate la îndemână",
                "c) ori de câte ori conducătorul consideră că este o manevră sigură"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "455. Înainte de pătrunderea în ecluză",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu trebuie făcute pregătiri speciale la bordul ambarcaţiunilor",
                "b) la bordul ambarcaţiunilor parâmele trebuie ţinute din scurt și componentele echipamentului trebuie să nu depăşească limitele navei",
                "c) conducătorul nu are nici o obligaţie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "456. În timpul ecluzării, în camerele ecluzelor",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este permis să se lase pasagerii să urce sau să coboare de la bord",
                "b) este interzis să se lase pasagerii să urce sau să coboare fără permisiunea personalului ecluzei",
                "c) nu este prevăzută expres această regulă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "457. Conducerea de skyjet este supusă următoarelor limite",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pe skyjet trebuie să se aplice numere de înmatriculare vizibile acordate de căpitănie",
                "b) pe skyjet nu trebuie să se aplice numere de înmatriculare, deoarece nu este loc",
                "c) nu sunt reguli prevăzute expres"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "458. Conducătorul ambarcațiunii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) poate să dea drumul timonei la orice viteză a bărcii",
                "b) poate să balanseze timona la o viteză mare a bărcii",
                "c) nu ar trebui să dea drumul timonei la nici un fel de viteză, din cauza forţelor turbionare prezente în sistemul de guvernare, barca ar putea să înceapă să se rotească rapid şi să devină instabilă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "459. Un motor înclinat în sus",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) are o abilitate de frânare mai redusă decât unul înclinat în jos şi este nevoie de mai mult spaţiu pentru a opri barca",
                "b) are o abilitate de a opri mai uşor barca",
                "c) nu are nici un fel de influenţă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "460. Schimbarea direcţiei de deplasare a ambarcaţiunii se realizează prin",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navigarea în ape cu salinități diferite",
                "b) punerea cârmei într-un bord sau altul şi este determinată de forţa curentului care apasă asupra penei cârmei, sau orientarea propulsorului în cazul propulsiei în ,,Z’’",
                "c) ambarcaţiunea schimbă direcţia când este influenţată de curent şi vânt"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "461. Prin rotaţia elicei se generează efect de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) propulsie şi guvernare",
                "b) propulsie",
                "c) guvernare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "462. Dacă înclinaţi motorul în sus la viteze mari",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu se observa nici un efect",
                "b) forţele turbionare vor acţiona brusc şi pot cauza pierderea controlului ambarcaţiunii",
                "c) barca se înclină în bordul pasului elicei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "463. La trecerea prin avanporturi de ecluză şi la intrarea în ecluze, navele trebuie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să-şi micşoreze viteza, pentru a fi posibilă în orice condiţii o oprire sigură cu ajutorul cablurilor de oţel, parâmelor şi a altor măsuri potrivite, astfel încât să fie exclusă o coliziune cu porţile ecluzei sau cu dispozitivele de protecţie.",
                "b) să execute manevra de intrare cu viteza cea mai mare pentru reducerea timpului de staţionare în ecluză",
                "c) nu sunt impuse reguli speciale"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "464. Ordinea ecluzării este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu există reguli privind ordinea ecluzării",
                "b) navele administraţiei; navele care sunt plecate pentru îndeplinirea unor misiuni excepţionale; navele avariate grav au prioritate la ecluzare în faţa celorlalte, fără a sta la rând; navele de pompieri şi de salvare aflate în drum spre locul accidentului; celelalte nave",
                "c) operatorul ecluzei dispune cum crede de cuviinţă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "465. O persoană care nu este pregătită pentru operarea unei bărci de mare viteză",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) poate încerca să conducă, crescând succesiv viteza fără instruire din partea unor conducători mai experimentaţi",
                "b) nu este nici o problemă, deoarece nu există riscuri",
                "c) nu ar trebui să încerce să conducă fără o instruire prealabilă şi o aplicaţie practică cu un conducător experimentat sau un dealer, pierderea controlului ar putea avea ca rezultat accidente grave"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "466. Înainte de a părăsi locul de acostare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu se fac nici un fel de verificări",
                "b) asiguraţi-vă că toate mecanismele folosite pentru a ataşa motorul de barcă sunt bine strânse şi la locul lor, procedaţi la fel pentru toată aparatura din sistemul de guvernare",
                "c) nu sunt reguli prevăzute expres"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "467. Ce fenomene hidrologice şi meteorologice pot influenţa manevra navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) vântul, valurile, curentul, adâncimi mari",
                "b) vântul, valurile, curentul",
                "c) vântul, valurile, curentul, adâncimi mici"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "468. În cazul în care ambarcaţiunea dvs. este utilizată în regim de mare viteză în mod constant, este nevoie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să alimentaţi mai des barca cu combustibil",
                "b) să schimbaţi uleiul mai des",
                "c) să fie verificate instalaţiile de elevare a motorului, de guvernare şi de cuplare- accelerare, precum şi elicea/elicele, la intervale mai scurte de timp"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "469. În ce constă manevrabilitatea bărcii?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) manevrabilitatea constă în capacitatea bărcii de a-şi menţine direcţia de înaintare sau de a schimba această direcţie cu ajutorul cârmei şi elicei",
                "b) manevrabilitatea consta în incapacitatea bărcii de a-si menţine direcţia de înaintare",
                "c) nu este o definiţie prevăzuta pentru aceasta caracteristica a ambarcaţiunii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "470. Elicea are pas dreapta dacă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la mersul înainte al ambarcaţiunii elicea se învârte la dreapta",
                "b) la mersul înapoi al ambarcaţiunii elicea se învârte la dreapta",
                "c) la mersul înainte al ambarcaţiunii elicea se învârte la stânga"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "471. Manevrele de acostare și plecare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sunt manevre simple, care nu solicită cunoştinţe de specialitate",
                "b) se fac numai cu piloţi specializaţi",
                "c) prezintă grad sporit de dificultate, solicitând cunoaşterea calităţilor manevriere ale navei și deprinderi marinăreşti"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "472. Reuşita ancorării depinde și de folosirea corectă a lungimii parâmei/lanţului de ancorare și anume:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lungimea parâmei/lanţului la ancoră trebuie să fie de 3-5 ori adâncimea măsurată",
                "b) nu sunt stabilite reguli speciale privind lungimea lanţului/parâmei de ancorare",
                "c) lungimea parâmei/lanţului de ancorare nu influenţează siguranţa ancorării"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "473. În zona de ecluze navele care sunt dotate cu o instalaţie de emisie–recepţie",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) închid aparatul VHF",
                "b) folosesc canalul pe care îl consideră util",
                "c) trebuie să aibă comutat la recepţie canalul ecluzei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "474. În timpul ecluzării, în camerele ecluzelor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este permis să se folosească după legarea navei și până la permiterea ieşirii atât propulsia mecanică, cât și instalaţia de guvernare prova",
                "b) nu este prevăzută expres această regulă",
                "c) este interzis să se folosească după legarea navei și până la permiterea ieşirii atât propulsia mecanică, cât și instalaţia de guvernare prova; din motive de siguranţă acest lucru este permis numai pentru fracţiuni scurte de timp"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "475. Motorul ataşabil al unei ambarcaţiuni se montează",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) având placa anticavitație la nivelul chilei ambarcaţiunii",
                "b) având placa anticavitație deasupra nivelului chilei ambarcaţiunii, la decalajul maxim permis de dispozitivul de fixare a motorului și dimensiunile oglinzii bărcii",
                "c) se poate monta oricum, deoarece nu sunt influenţaţi parametrii de mişcare ai bărcii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "476. În cazul în care ambarcaţiunea dvs. este utilizată în regim de mare viteză în mod constant, este nevoie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să alimentaţi mai des barca cu combustibil",
                "b) să schimbaţi uleiul mai des",
                "c) să fie verificate instalaţiile de elevare a motorului, de guvernare şi de cuplare- accelerare, precum şi elicea/elicele, la intervale mai scurte de timp"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "477. La deplasarea înapoi a bărcii, efectul cârmei determină",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu are nici o influenţă",
                "b) orientarea provei în bordul în care s- a pus cârma şi a pupei în sensul opus cârmei",
                "c) orientarea provei în bordul opus celui în care s-a pus cârma şi a pupei în sensul punerii cârmei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "478. La marş înapoi, pupa este abătută:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în bordul opus pasului elicei, iar prova va gira în bordul pasului elicei",
                "b) spre stânga",
                "c) spre dreapta"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "479. Acostarea ambarcaţiunii la o navă se face în următoarele condiţii",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nava la care urmează a se acosta reduce viteza și păstrează direcţia fără abatere, iar ambarcaţiunea va acosta totdeauna în bordul de sub vânt şi cât mai spre centrul navei",
                "b) nu contează condiţiile",
                "c) aceasta manevră este interzisă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "480. La întâlniri, conducătorul ambarcaţiunii",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) păstrează direcţia şi viteza de deplasare",
                "b) va reduce viteza în întâmpinarea valurilor provocate de nava ce vine din sens opus şi va adopta o viteză corespunzătoare evitării răsturnării",
                "c) se vor evita constant întâlnirile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "481. În camerele ecluzei",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navele trebuie să se menţină în interiorul limitelor, în cazul în care pe pereţii ecluzelor sunt marcate graniţe/limite",
                "b) navele se pot lega oriunde consideră",
                "c) nu este nevoie de legarea navelor în timpul ecluzării"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "482. Schiul nautic pe căile navigabile interioare este permis",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) numai în zonele stabilite şi marcate, acest lucru fiind valabil şi pentru activităţi în care persoanele sunt trase de o ambarcaţiune fără schiuri nautice sau pe altfel de obiecte",
                "b) fără restricţie de zonă, deoarece ambarcaţiunile au o viteză mare",
                "c) nu sunt reguli prevăzute special pentru schiul nautic"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "483. Când motorul este înclinat în jos la capătul cursei",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) barca glisează orizontal pe apă",
                "b) pupa bărcii va intra mai adânc în apă, la ambarcaţiunile mai mici se observă apuparea",
                "c) înclinarea motorului/cizmei nu influenţează alura deplasării"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "484. Pasul elicei reprezintă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mărimea diametrului butucului",
                "b) lungimea palei",
                "c) spaţiul parcurs de marginea exterioară a elicei, în mişcarea de translaţie efectuată de-a lungul axei de rotaţie în timpul unei rotaţii complete"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "485. Guvernarea clasică poate fi ajutată prin instalarea în corpul ambarcaţiunii de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) propulsoare prova şi pupa (bowtruster și sterntruster)",
                "b) reducerea suprafeţei penei cârmei",
                "c) micşorarea unghiului de rotire a cârmei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "486. Conducerea de skyjet pe căile navigabile interioare",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este interzisă",
                "b) este permisă numai în porţiunile stabilite şi marcate",
                "c) nu sunt reguli expres enunţate"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "487. Dacă barca pe care aţi cumpărat-o nu are placa de capacitate",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu este nici o problemă, parametrii limită de exploatare pot fi apreciaţi",
                "b) contactaţi dealer-ul dumneavoastră sau producătorul bărcii, pentru a intra în posesia informaţiilor garantate",
                "c) calculaţi dumneavoastră datele de care aveţi nevoie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "488. Înainte de a părăsi locul de acostare",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) verificaţi funcţionarea butonului pentru oprire de urgenţă, daţi drumul motorului, trageţi saula şi vedeţi dacă motorul se opreşte; asiguraţi-vă că saula este bine legată de hainele sau vesta dumneavoastră de salvare",
                "b) nu se fac nici un fel de verificări",
                "c) nu trebuie legată saula de haine sau vesta de salvare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "489. Dacă pupa intră adânc în apă, datorită înclinării motorului la viteze mari",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) barca ar putea să înceapă să se rotească rapid şi să se arunce pasagerii peste bord",
                "b) barca îşi măreşte stabilitatea de drum",
                "c) nu se observă nici un efect"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Manevra",
            "difficulty": 1
        },
        {
            "question": "1. Care este durata maximă a masajului cardio-respitator?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 30 - 40 min",
                "b) 10 - 15 min",
                "c) 60 min"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "2. Care este prima acțiune întreprinsă la acordarea primului ajutor victimelor unei coliziuni?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) spalarea plăgilor",
                "b) dezinfectarea și pansarea rănilor",
                "c) degajarea căilor respiratorii și asigurarea funcției respiratorii"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "3. Care este prima măsură pe care o luați în cazul accidentării unei persoane pe apă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) transportul imediat până la prima localitate și anunțarea la 112",
                "b) transportul la cel mai apropiat spital",
                "c) acordarea primului ajutor până la sosirea cadrelor de pe ambulanță"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "4. Care este rolul bandajului?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să prevină murdărirea hainelor",
                "b) să împiedice hemoragia",
                "c) să împiedice intrarea corpilor străini în rană"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "5. Care poate fi cauza obturării căilor respiratorii după o coliziune?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) inflamarea mucoasei nazale",
                "b) poziția necorespunzătoare în care a fost așezată victima",
                "c) intrarea unor corpi străini în nasul sau gura victimei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "6. Care sunt simptomele unei fracturi a membrelor?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) temperatura ridicată a membrului fraturat",
                "b) decolorarea zonei fraturate",
                "c) poziția nefirească a membrului respectiv miscarea nenaturală"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "7. Care tip de hemoragie este cea mai periculoasă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) hemoragia arterială",
                "b) hemoragia venoasă",
                "c) hemoragia care determină o pierdere rapidă a sângelui"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "8. Ce criterii trebuie să îndeplinească o atelă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să fie suficient de lungă pentru a imobiliza articulațiile superioară și inferioară a membrului fracturat și să fie rigidă",
                "b) să fie rigidă",
                "c) să fie sterilă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "9. Ce manevre se fac pentru a acorda primul ajutor în caz de fracturi de membre?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se imobilizează membrul în atele care să fie destul de lungi pentru a cuprinde articulația de deasupra și cea de dedesubtul fracturii",
                "b) se unesc capetele oaselor care au ieșit prin piele, apoi se bandajează locul",
                "c) se aplică un garou deasupra fracturii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "10. Ce măsuri de iau în cazul victimelor cu fracturi de claviculă (umărul victimei este deplasat usor înainte și în jos?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) aduceți umărul în poziție normală",
                "b) culcați victima pe spate",
                "c) suspendați brațul într-o eșarfă sau chingă delată de gât"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "11. Ce măsuri de prim ajutor se iau în cazul victimelor care nu mai au puls?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se efectuează doar masaj cardiac",
                "b) se efectuează doar respirație artificială",
                "c) se efectuează masaj cardio respirator"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "12. Ce măsuri de prim ajutor se iau în cazul victimelor care prezintă o entorsă a gleznei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se aplică un bandaj elastic strâns, eventual se aplică și gheață",
                "b) se imobilizează glezna cu atele",
                "c) se transportă urgent victima la mal"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "13. Ce măsuri de prim ajutor se iau în cazul victimelor care prezintă plăgi tăiate?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se transportă de urgență victima la spital",
                "b) se coase plaga",
                "c) se oprește hemoragia și se transportă victima la spital"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "14. Ce măsuri de prim ajutor se iau în cazul victimelor care și au pierdut cunoștința?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se verifică existența pulsului și a respirației",
                "b) se administrează medicamente de resuscitare",
                "c) se imobilizează membrele"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "15. Ce măsuri de prim ajutor se iau în cazul victimelor cu traumatisme ale coloanei vertebrale, dacă funcțiile vitale ale acesteia sunt asigurate?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se transportă imediat victima la spital cu orice mijloc de transport aflat la îndemână",
                "b) se transportă imediat victima la spital așezată pe o platformă improvizată",
                "c) dacă nu există un alt pericol, nu se mișcă accidentatul din poziția în care se află până la sosirea serviciilor de urgență"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "16. Ce rol au bandajele?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) imobilizează fracturile",
                "b) dezinfectează rănile",
                "c) acoperă rănile, eventual opresc hemoragiile"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "17. Ce trebuie să urmăriți la scoaterea victimelor dintr o ambarcațiune accidentată?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să nu produceți pagube suplimentare ambarcațiunii accidentate",
                "b) să nu le agravați leziunile",
                "c) să conservați urmele accidentului"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "18. Cu ce se pot transporta la spital victimele unui accident naval, după ce au fost scoase la mal?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Cu orice vehicul, dacă situația victimei permite acest lucru",
                "b) numai cu ambulanța SMURD",
                "c) cu o ambulanță însoțită de un medic specialist"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "19. Cum extrageți corpii străini din interiorul plăgilor?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin spalare cu apă",
                "b) prin extragere cu mâna",
                "c) renunțăm la asemenea manevră întrucât riscăm să agravăm starea victimei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "20. Cum pot fi recunoscute fracturile la membrele victimelor unei coliziuni?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin elasticitatea exagerată a membrului fracturat",
                "b) prin culoarea roșie a zonei fracturate",
                "c) prin mișcarea nenaturală a membrului fracturat"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "21. Cum procedați dacă în timpul masajului cardio-respirator victima își recapătă pulsul?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) continuați compresiile exterioare ale pieptului",
                "b) încetați compresiile exterioare ale pieptului",
                "c) continuați cu respirație artificială"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "22. Cum procedați pentru a evita complicațiile în cazul unei fracturi?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) suspendați zona fracturată cu o fașă",
                "b) imobilizați zona fracturată",
                "c) sterilizați zona fracturată"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "23. Cum se imobilizează fractura labei piciorului?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu o atelă de la gleznă până la genunchi",
                "b) prin fixarea piciorului într-o chingă de piele",
                "c) cu atele sau bandaj, cât mai rigide, de la degete până la genunchi"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "24. Cum se imobilizează membrele superioare care au suferit fracturi?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu o eșarfă",
                "b) cu o legătură elastică",
                "c) cu atele, chiar improvizate"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "25. Cum se poate imobiliza o fractură fără atele?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu carton",
                "b) cu folie de material plastic",
                "c) cu eșarfe și triunghiuri de pânză"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "26. Cum se recunoaște o fractură deschisă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) zona fracturată nu se poate mișca",
                "b) zona fracturată este înroșită",
                "c) pielea este străpunsă în zona fracturii și se vede osul"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "27. Cum trebuie așezat accidentatul care prezintă hemoragie externă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) astfel încât zona să fie mai jos decât nivelul corpului",
                "b) astfel încât zona să fie mai sus decât nivelul corpului",
                "c) cu picioarele mai sus decât nivelul capului"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "28. Cum trebuie așezată o persoană rănită care prezintă leziuni ale coloanei vertebrale?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dacă este posibil, victima nu trebuie mișcată până la sosirea medicului",
                "b) orizontal, cu fața în jos",
                "c) orizontal, cu fața în sus"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "29. Cum trebuie resuscitată o victimă a unei coliziuni, care are puls, dar nu respiră?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin aplicarea de palme peste fața victimei",
                "b) prin masaj cardio-respirator",
                "c) prin executarea respirației artificiale"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "30. Cum trebuie să fie atela destinată imobilizării unei fracturi?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) flexibilă",
                "b) cât mai rigidă și suficient de lungă pentru a cuprinde articulațiile superioară și inferioară a membrului fracturat",
                "c) cât mai scurtă pentru a nu incomoda rănitul"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "31. Cum veți proceda dacă victima căreia i-ați efectuat masaj cardio- respirator își revine?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) așteptați să vedeți cum evoluează starea ei de sănătate",
                "b) o conduceți la mal",
                "c) luați măsuri pentru transportarea ei la spital"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "32. Hemoragia nazală a unei victime se poate opri dacă aceasta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) stă culcată cu mâna stângă ridicată deasupra capului",
                "b) stă culcată cu capul dat pe spate",
                "c) își strânge ambele nări cu degetele timp de aproximativ 5-10 minute"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "33. În cazul unei coliziuni din care au rezultat mai multe victime, primul ajutor se acordă mai întâi:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) victimei cu cele mai mari șanse de supraviețuire",
                "b) victimei care comunică ușor",
                "c) victimei în starea cea mai gravă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "34. În ce constă primul ajutor în caz de traumatism al capului?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) aplicarea unor comprese pe frunte și pansarea părților tumefiate",
                "b) imobilizarea capului cu un dispozitiv improvizat",
                "c) bandajarea plăgilor, degajarea căilor respiratorii, așezarea victimei pe o suprafață plană"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "35. În ce loc se execută degajarea căilor respiratorii ale victimei unei coliziuni?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la locul producerii coliziunii, cât mai urgent",
                "b) la spital, cu instrumente speciale",
                "c) la sosirea ambulanței, de către personalul specializat"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "36. În ce ordine se va lua măsurile de prim ajutor în funcție de starea victimei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) oprirea hemoragiei, respirație artificială, masaj cardiac, pansarea rănilor, imobilizarea fracturilor",
                "b) pansarea rănilor, imobilizarea fracturilor, oprire hemoragie, respirație artificială, masaj cardiac",
                "c) imobilizarea fracturilor, pansarea rănilor, respirație artificială, masaj cardiac, oprirea hemoragiei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "37. Masajul cardio-respirator trebuie efectuat victimelor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) care nu respiră",
                "b) care nu au puls și nu respiră",
                "c) care au suferit traumatisme craniene"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "38. Transportul victimelor unei coliziuni care prezintă hemoragii se face?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) imediat după oprirea hemoragiei",
                "b) imediat după pansarea rănilor",
                "c) imediat după anunțarea coliziunii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "39. Unde se verifică dacă victima unei coliziuni are puls, dacă aceasta respiră?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lângă mărul lui Adam, în scobitura dintre trahee și mușchii gâtului",
                "b) în zona inimii",
                "c) la încheietura mâinii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "40. Unde trebuie aplicat garoul de cauciuc în cazul persoanelor rănite care prezintă plăgi însoțite de hemoragii arteriale?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) peste plagă",
                "b) sub plagă",
                "c) deasupra plăgii"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "41. Substanțele antiseptice se folosesc pentru:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) calmarea durerilor",
                "b) dezinfectarea rănilor",
                "c) oprirea hemoragiei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "42. Victima care a pierdut mult sânge trebuie să fie așezată:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu fața în sus",
                "b) cu picioarele situate mai sus decât restul corpului",
                "c) cu fața în jos"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "43. În cazul rănilor cu hemoragie se va avea în vedere la început:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pansarea rănii",
                "b) curățarea și pansarea rănii",
                "c) oprirea hemoragiei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "44. Când gura unui rănit rămâne încleștată respirația artificială se poate face?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin gura închisă a victimei",
                "b) prin nările victimei",
                "c) nu se mai face respirație artificială în acest caz"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "45. Cât poate fi menținut un garou pentru a nu afecta țesuturile?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) minimum 2 ore",
                "b) maximum 4 ore",
                "c) maximum 2 ore"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "46. Dezinfectarea plăgilor ce necesită a fi pansate se face cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) apă oxigenată sau iod",
                "b) ser fiziologic",
                "c) apă potabilă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "47. Cum se opresc hemoragiile la trunchi și cap?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin aplicarea unui garou de cauciuc",
                "b) prin orice mijloace",
                "c) compreselor sterile și a pansamentelor compresive"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "48. Cum procedați în cazul unei victime cu multiple arsuri pe cap și membre?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) arsurile se spală, se bandajează și apoi victima este transportată la cea mai apropiată unitate medicală",
                "b) după stingerea flăcărilor persoana este dezbrăcată rapid de hainele arse",
                "c) trebuie să fie transportată imediat la o unitate medicală"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "49. Biletul care se prinde lângă garoul aplicat unei persoane rănite trebuie să conțină:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) poziția în care a fost găsită victima",
                "b) ora și minutul aplicării garoului",
                "c) numele persoanei care l-a aplicat"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "50. Ce trebuie să conțină un pansament aplicat pe plagă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o compresă de tifon steril",
                "b) o compresă de orice tip",
                "c) o compresă de vată sterilă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "1. Care din următoarele fapte constituie infracțiune?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) îmbarcarea de pasageri peste limita admisă",
                "b) schimbarea poziției, scoaterea din funcțiune, avarierea gravă sau distrugerea unui semnal de navigație",
                "c) nerespectarea dispozițiilor personalului de la ecluze"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "2. Care dintre următoarele fapte constituie infracțiune?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) necomunicarea unor informații",
                "b) refuzul de a pune la dispoziția ANR documente și date necesare investigării",
                "c) împiedicarea îndeplinirii atribuțiilor de serviciu ale personalului navigant"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "3. Care este cauza agravantă a infracțiunii de preluare fără drept a comenzii sau controlului unei nave?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dacă fost făcută în scopul devierii navei de la itinerarul său",
                "b) dacă a fost făcută de către un membru al echipajului",
                "c) dacă a fost făcută de două sau mai multe persoane"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "4. Luarea în stăpânire a unei platforme fixe sau exercitarea controlului asupra acesteia constituie infracțiune?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da, dacă s a produs prin violență ori amenințare cu violența",
                "b) da, dacă s a produs în scopul devierii de la itinerarul său",
                "c) da, dacă s-a perturbat funcționarea acesteia sau s-a pus în pericol siguranța navigației"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "5. Ce reprezintă blocarea șenalului navigabil a unei dane sau a bazinului portuar și neexecutarea ordinului căpitanului portului privind măsurile de deblocare?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) contravenție, dacă este fără urmări",
                "b) infracțiune",
                "c) infracțiune, dar numai dacă a avut ca urmare întreruperea navigației ori a activității portuare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "6. Ultrajul săvârșit împotriva personalului operativ al căpităniei portului, constituie infracțiune?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da, dacă persoana se află în exercițiul funcțiunii",
                "b) da, chiar dacă este ca urmare a unor fapte îndeplinite în afara exercițiului funcțiunii",
                "c) da, dacă are ca urmare punerea în pericol a siguranței navigației"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "7. În ce termen trebuie transcris contractul de construcție al unei nave în registrul de evidență al navelor în construcție?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 15 zile de la începerea construcției",
                "b) 15 zile înainte de începerea construcției",
                "c) 15 zile înainte de finalizarea construcției"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "8. Care este termenul în care proprietarul unei nave are obligația de a înmatricula nava?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 15 zile",
                "b) 30 zile",
                "c) 60 zile"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "9. Care este termenul limită pentru depunerea la căpitănia portului a actului de naționalitate de către proprietar în cazul suspendării dreptului de arborare a pavilionului român?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 15 zile de când decizia a rămas definitivă",
                "b) 30 de zile de la comunicarea deciziei",
                "c) 15 zile de la comunicarea deciziei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "10. Exploatarea în scopuri comerciale a ambarcațiunii de agrement, cu excepția celor autorizate în acest sens, constituie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) infracțiune, dacă periclitează siguranța navigației",
                "b) contravenție la regimul siguranței navigației",
                "c) infracțiune, dacă se depășește numărul maxim de pasageri"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "11. Folosirea de către proprietar a unui nume, număr de identificare sau port de înmatriculare ce nu a fost aprobat de Autoritatea competentă constituie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) contravenție",
                "b) infracțiune la regimul înmatriculări navelor",
                "c) contravenție, dacă nava a fost depistată pe șenalul navigabil"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "12. Care este sancțiunea pentru nerespectarea ”Avizelor către navigatori”?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 20.000 la 50.000 lei",
                "b) amendă de la 5.000 la 10.000 lei",
                "c) amendă de la 10.000 la 20.000 lei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "13. Care este sancțiunea pentru navigația în zone nepermise a unei nave?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 20.000 la 50.000 lei",
                "b) amendă de la 5.000 la 20.000 lei",
                "c) amendă de la 10.000 la 20.000 lei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "14. Care este sancțiunea pentru așezarea de plase ori unelte fixe de pescuit în apele naționale navigabile precum și în rade, portur,i canale sau senale navigabile?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 10.000 la 30.000 lei",
                "b) amendă de la 5.000 la 10.000 lei",
                "c) amendă de la 5.000 la 20.000 lei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "15. Care este sancțiunea pentru folosirea mijloacelor de semnalizare de la bord în mod nejustificat sau neadecvat regulamentelor de navigație?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 10.000 la 20.000 lei",
                "b) amendă de la 5.000 la 20.000 lei",
                "c) amendă de la 1.000 la 5.000 lei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "16. Care este sancțiunea pentru poluarea apelor naționale navigabile cu hidrocarburi?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 5.000 la 20.000 lei",
                "b) amendă de la 1.000 la 8.000 lei",
                "c) amendă de la 20.000 la 40.000 lei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "17. Care este sancțiunea pentru refuzul prezentării documentului de atestare reprezentanților ANR?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 2.000 la 5.000 lei",
                "b) amendă de la 1.000 la 5.000 lei",
                "c) amendă de la 500 la 8.000 lei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "18. Care este sancțiunea pentru neanunțarea de către conducătorul unei nave cu privire la evenimentele de navigație ale propriei nave cum ar fi: abordaje, coliziuni, incendii, poluare, scufundare?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 40.000 la 50.000 lei",
                "b) amendă de la 5.000 la 10.000 lei",
                "c) amendă de la 5.000 la 20.000 lei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "19. Care este sancțiunea pentru nearborarea la la bordul navei a pavilionului național în apele naționale navigabile ale României?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 2.000 la 5.000 lei",
                "b) amendă de la 1.000 la 5.000 lei",
                "c) amendă de la 5.000 la 20.000 lei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "20. Cum se sancționează refuzul de a se supune cercetărilor întreprinse de ANR sau de a pune la dispoziția ANR documentele și datele necesare investigării:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 1.000 la 5.000 lei",
                "b) amendă de la 30.000 la 50.000 lei",
                "c) amendă de la 10.000 la 20.000 lei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "21. Cum se sancționează refuzul de a se supune controlului ANR",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 1.000 la 5.000 lei",
                "b) amendă de la 5.000 la 20.000 lei",
                "c) amendă de la 20.000 la 30.000 lei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "22. Nepredarea la ANR în termen de 5 zile de la comunicarea deciziei de suspendare sau anulare a documentului de atestare se sancționează:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 100 la 500 lei",
                "b) amendă de la 100 la 1.000 lei",
                "c) amendă de la 1.000 la 5.000 lei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "23. Constatarea contravențiilor și aplicarea sancțiunilor prevăzute de HG 1704/2024 se face de către:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) personalul împuternicit al ANR",
                "b) personal ANR în asistență reprezentant poliție transporturi navale",
                "c) personalul ANR în asistență reprezentant Administrația Portuară"
            ],
            "correctAnswer": [
                1
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "24. Se poate constata contravenția fără oprirea navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da",
                "b) nu",
                "c) da, dacă săvârșirea contravenției este probată cu un mijloc tehnic"
            ],
            "correctAnswer": [
                3
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        },
        {
            "question": "25. Se poate constata contravenția în lipsa contravenientului?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da, dacă săvârșirea contravenției este probată cu un mijloc tehnic",
                "c) da"
            ],
            "correctAnswer": [
                2
            ],
            "section": "C-Legislatie",
            "difficulty": 1
        }
    ]
};
